export const iconListData = [
  {
    "name": "banknote",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "misc"
    ],
    "unicode": "e000",
    "id": 970,
    "tags": [
      "banknote",
      "misc"
    ]
  },
  {
    "name": "globe",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "maps"
    ],
    "unicode": "e001",
    "id": 971,
    "tags": [
      "world",
      "earth",
      "global",
      "planet",
      "circle",
      "round",
      "internationalization",
      "i18n",
      "languages",
      "country",
      "countries",
      "geography",
      "internet"
    ]
  },
  {
    "name": "accessibility",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e002",
    "id": 972,
    "tags": [
      "accessibility",
      "actions",
      "a11y",
      "inclusive",
      "universal"
    ]
  },
  {
    "name": "aggregate-fields",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "files-and-folders"
    ],
    "unicode": "e003",
    "id": 973,
    "tags": [
      "aggregate",
      "fields",
      "files-and-folders"
    ]
  },
  {
    "name": "align-bottom",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "text-formatting"
    ],
    "unicode": "e004",
    "id": 974,
    "tags": [
      "alignment",
      "arrangement",
      "layout",
      "flush bottom"
    ]
  },
  {
    "name": "align-center",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "text-formatting"
    ],
    "unicode": "e005",
    "id": 975,
    "tags": [
      "align",
      "center",
      "text-formatting",
      "position",
      "arrange",
      "layout"
    ]
  },
  {
    "name": "align-items-center-alt",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e006",
    "id": 976,
    "tags": [
      "align",
      "items",
      "center",
      "alt",
      "editing",
      "position",
      "arrange",
      "layout"
    ]
  },
  {
    "name": "align-items-center",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e007",
    "id": 977,
    "tags": [
      "align",
      "items",
      "center",
      "editing",
      "position",
      "arrange",
      "layout"
    ]
  },
  {
    "name": "align-items-end-alt",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e008",
    "id": 978,
    "tags": [
      "align",
      "items",
      "end",
      "alt",
      "editing",
      "position",
      "arrange",
      "layout"
    ]
  },
  {
    "name": "align-items-end",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e009",
    "id": 979,
    "tags": [
      "align",
      "items",
      "end",
      "editing",
      "position",
      "arrange",
      "layout"
    ]
  },
  {
    "name": "align-items-start-alt",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e00a",
    "id": 980,
    "tags": [
      "align",
      "items",
      "start",
      "alt",
      "editing",
      "position",
      "arrange",
      "layout"
    ]
  },
  {
    "name": "align-items-start",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e00b",
    "id": 981,
    "tags": [
      "align",
      "items",
      "start",
      "editing",
      "position",
      "arrange",
      "layout"
    ]
  },
  {
    "name": "align-justify",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "text-formatting"
    ],
    "unicode": "e00c",
    "id": 982,
    "tags": [
      "align",
      "justify",
      "text-formatting",
      "position",
      "arrange",
      "layout"
    ]
  },
  {
    "name": "align-left",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "text-formatting"
    ],
    "unicode": "e00d",
    "id": 983,
    "tags": [
      "alignment",
      "arrangement",
      "layout",
      "flush left"
    ]
  },
  {
    "name": "align-middle",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "text-formatting"
    ],
    "unicode": "e00e",
    "id": 984,
    "tags": [
      "align",
      "middle",
      "text-formatting",
      "position",
      "arrange",
      "layout"
    ]
  },
  {
    "name": "align-right",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "text-formatting"
    ],
    "unicode": "e00f",
    "id": 985,
    "tags": [
      "alignment",
      "arrangement",
      "layout",
      "flush right"
    ]
  },
  {
    "name": "align-top",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "text-formatting"
    ],
    "unicode": "e010",
    "id": 986,
    "tags": [
      "alignment",
      "arrangement",
      "layout",
      "flush top"
    ]
  },
  {
    "name": "all",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "text-formatting"
    ],
    "unicode": "e011",
    "id": 987,
    "tags": [
      "all",
      "text-formatting"
    ]
  },
  {
    "name": "anchor",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e012",
    "id": 988,
    "tags": [
      "nautical",
      "boats",
      "ships",
      "hope",
      "safety",
      "insurance"
    ]
  },
  {
    "name": "apply-format",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e013",
    "id": 989,
    "tags": [
      "apply",
      "format",
      "editing"
    ]
  },
  {
    "name": "area",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e014",
    "id": 990,
    "tags": [
      "area",
      "editing",
      "chart",
      "graph",
      "region"
    ]
  },
  {
    "name": "arrow-down-left",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "arrows"
    ],
    "unicode": "e015",
    "id": 991,
    "tags": [
      "directional",
      "pointer",
      "pointing",
      "arrowhead"
    ]
  },
  {
    "name": "arrow-down",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "navigation",
      "arrows"
    ],
    "unicode": "e016",
    "id": 992,
    "tags": [
      "directional",
      "pointer",
      "pointing",
      "arrowhead"
    ]
  },
  {
    "name": "arrow-left",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "navigation",
      "arrows"
    ],
    "unicode": "e017",
    "id": 993,
    "tags": [
      "directional",
      "pointer",
      "pointing",
      "arrowhead"
    ]
  },
  {
    "name": "arrow-overflow-down",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "navigation"
    ],
    "unicode": "e018",
    "id": 994,
    "tags": [
      "arrow",
      "overflow",
      "down",
      "navigation",
      "direction",
      "navigate",
      "pointer"
    ]
  },
  {
    "name": "arrow-right",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "navigation",
      "arrows"
    ],
    "unicode": "e019",
    "id": 995,
    "tags": [
      "directional",
      "pointer",
      "pointing",
      "arrowhead"
    ]
  },
  {
    "name": "arrow-rotate-ccw",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e01a",
    "id": 996,
    "tags": [
      "arrow",
      "rotate",
      "ccw",
      "actions",
      "direction",
      "navigate",
      "pointer",
      "turn",
      "spin",
      "orientation"
    ]
  },
  {
    "name": "arrow-rotate-cw",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e01b",
    "id": 997,
    "tags": [
      "arrow",
      "rotate",
      "cw",
      "actions",
      "direction",
      "navigate",
      "pointer",
      "turn",
      "spin",
      "orientation"
    ]
  },
  {
    "name": "arrow-shape",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e01c",
    "id": 998,
    "tags": [
      "arrow",
      "shape",
      "editing",
      "direction",
      "navigate",
      "pointer",
      "form",
      "polygon",
      "geometry"
    ]
  },
  {
    "name": "arrow-up",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "navigation",
      "arrows"
    ],
    "unicode": "e01d",
    "id": 999,
    "tags": [
      "directional",
      "pointer",
      "pointing",
      "arrowhead"
    ]
  },
  {
    "name": "arrows-axes",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "navigation",
      "arrows"
    ],
    "unicode": "e01e",
    "id": 1000,
    "tags": [
      "arrows",
      "axes",
      "navigation"
    ]
  },
  {
    "name": "arrows-left-right",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "arrows"
    ],
    "unicode": "e01f",
    "id": 1001,
    "tags": [
      "directional",
      "pointer",
      "pointing",
      "arrowhead"
    ]
  },
  {
    "name": "arrows-move",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e020",
    "id": 1002,
    "tags": [
      "arrows",
      "move",
      "actions"
    ]
  },
  {
    "name": "drag-and-drop",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "navigation"
    ],
    "unicode": "e021",
    "id": 33,
    "tags": [
      "drag",
      "and",
      "drop",
      "navigation",
      "move",
      "reorder",
      "handle",
      "release",
      "place"
    ]
  },
  {
    "name": "arrows-no-change",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "navigation"
    ],
    "unicode": "e022",
    "id": 1003,
    "tags": [
      "arrows",
      "no",
      "change",
      "navigation"
    ]
  },
  {
    "name": "arrows-no-repeat",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e023",
    "id": 1004,
    "tags": [
      "arrows",
      "no",
      "repeat",
      "actions"
    ]
  },
  {
    "name": "grid-layout",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "layout"
    ],
    "unicode": "e024",
    "id": 36,
    "tags": [
      "grid",
      "layout",
      "tiles",
      "view",
      "template",
      "design"
    ]
  },
  {
    "name": "arrows-swap",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "navigation",
      "arrows"
    ],
    "unicode": "e025",
    "id": 1005,
    "tags": [
      "arrows",
      "swap",
      "navigation"
    ]
  },
  {
    "name": "arrows-top-bottom",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "arrows"
    ],
    "unicode": "e026",
    "id": 1006,
    "tags": [
      "arrows",
      "top",
      "bottom"
    ]
  },
  {
    "name": "handle-drag",
    "ligatures": [],
    "aliases": [
      "handler-drag"
    ],
    "categories": [
      "layout"
    ],
    "unicode": "e027",
    "id": 39,
    "tags": [
      "handle",
      "drag",
      "handler",
      "layout",
      "move",
      "reorder"
    ]
  },
  {
    "name": "layout",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "layout"
    ],
    "unicode": "e028",
    "id": 40,
    "tags": [
      "wireframe",
      "sidebar",
      "ui",
      "interface"
    ]
  },
  {
    "name": "layout-1-by-4",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "layout"
    ],
    "unicode": "e029",
    "id": 41,
    "tags": [
      "layout",
      "1",
      "by",
      "4",
      "grid",
      "template",
      "design"
    ]
  },
  {
    "name": "layout-2-by-2",
    "ligatures": [],
    "aliases": [
      "page-layout"
    ],
    "categories": [
      "layout"
    ],
    "unicode": "e02a",
    "id": 42,
    "tags": [
      "layout",
      "2",
      "by",
      "page",
      "grid",
      "template",
      "design"
    ]
  },
  {
    "name": "layout-side-by-side",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "layout"
    ],
    "unicode": "e02b",
    "id": 43,
    "tags": [
      "layout",
      "side",
      "by",
      "grid",
      "template",
      "design"
    ]
  },
  {
    "name": "layout-stacked",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "layout"
    ],
    "unicode": "e02c",
    "id": 44,
    "tags": [
      "layout",
      "stacked",
      "grid",
      "template",
      "design"
    ]
  },
  {
    "name": "barcode-scanner",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e02d",
    "id": 1007,
    "tags": [
      "barcode",
      "scanner",
      "actions"
    ]
  },
  {
    "name": "barcode",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e02e",
    "id": 1008,
    "tags": [
      "upc",
      "qr",
      "products",
      "shopping",
      "scanner"
    ]
  },
  {
    "name": "behance",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "social"
    ],
    "unicode": "e02f",
    "id": 1009,
    "tags": [
      "behance",
      "social"
    ]
  },
  {
    "name": "bell",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "notifications"
    ],
    "unicode": "e030",
    "id": 1010,
    "tags": [
      "alarm",
      "notifications",
      "times",
      "timer",
      "clock",
      "schedule",
      "events",
      "ringer",
      "calls"
    ]
  },
  {
    "name": "bicycle",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "misc"
    ],
    "unicode": "e031",
    "id": 1011,
    "tags": [
      "bikers",
      "bicycling",
      "cyclists",
      "transit",
      "transportation",
      "commuter",
      "exercises",
      "fitness"
    ]
  },
  {
    "name": "binoculars",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e032",
    "id": 1012,
    "tags": [
      "telescope",
      "glasses",
      "search",
      "find",
      "explore"
    ]
  },
  {
    "name": "overlap",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "layout"
    ],
    "unicode": "e033",
    "id": 51,
    "tags": [
      "overlap",
      "layout"
    ]
  },
  {
    "name": "blur",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "images"
    ],
    "unicode": "e034",
    "id": 1013,
    "tags": [
      "blur",
      "images"
    ]
  },
  {
    "name": "bold",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "text-formatting"
    ],
    "unicode": "e035",
    "id": 1014,
    "tags": [
      "bold",
      "text-formatting",
      "strong",
      "text"
    ]
  },
  {
    "name": "book",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e036",
    "id": 1015,
    "tags": [
      "reading",
      "reader",
      "novel",
      "story",
      "library"
    ]
  },
  {
    "name": "border-radius-bottom-left",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "css",
      "borders"
    ],
    "unicode": "e037",
    "id": 55,
    "tags": [
      "border",
      "radius",
      "bottom",
      "left",
      "css",
      "borders"
    ]
  },
  {
    "name": "border-radius-bottom-right",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "css",
      "borders"
    ],
    "unicode": "e038",
    "id": 56,
    "tags": [
      "border",
      "radius",
      "bottom",
      "right",
      "css",
      "borders"
    ]
  },
  {
    "name": "border-radius-top-left",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "css",
      "borders"
    ],
    "unicode": "e039",
    "id": 57,
    "tags": [
      "border",
      "radius",
      "top",
      "left",
      "css",
      "borders"
    ]
  },
  {
    "name": "border-radius-top-right",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "css",
      "borders"
    ],
    "unicode": "e03a",
    "id": 58,
    "tags": [
      "border",
      "radius",
      "top",
      "right",
      "css",
      "borders"
    ]
  },
  {
    "name": "border-radius",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "css",
      "borders"
    ],
    "unicode": "e03b",
    "id": 59,
    "tags": [
      "border",
      "radius",
      "css",
      "borders"
    ]
  },
  {
    "name": "border-style-bottom",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "css",
      "borders"
    ],
    "unicode": "e03c",
    "id": 60,
    "tags": [
      "border",
      "style",
      "bottom",
      "css",
      "borders"
    ]
  },
  {
    "name": "border-style-left",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "css",
      "borders"
    ],
    "unicode": "e03d",
    "id": 61,
    "tags": [
      "border",
      "style",
      "left",
      "css",
      "borders"
    ]
  },
  {
    "name": "border-style-right",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "css",
      "borders"
    ],
    "unicode": "e03e",
    "id": 62,
    "tags": [
      "border",
      "style",
      "right",
      "css",
      "borders"
    ]
  },
  {
    "name": "border-style-top",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "css",
      "borders"
    ],
    "unicode": "e03f",
    "id": 63,
    "tags": [
      "border",
      "style",
      "top",
      "css",
      "borders"
    ]
  },
  {
    "name": "border-style",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "css",
      "borders"
    ],
    "unicode": "e040",
    "id": 64,
    "tags": [
      "border",
      "style",
      "css",
      "borders"
    ]
  },
  {
    "name": "border-color",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "borders"
    ],
    "unicode": "e041",
    "id": 1016,
    "tags": [
      "border",
      "color",
      "borders",
      "paint",
      "palette",
      "fill"
    ]
  },
  {
    "name": "box-sizing",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "css",
      "layout"
    ],
    "unicode": "e042",
    "id": 1017,
    "tags": [
      "box",
      "sizing",
      "css",
      "layout",
      "container",
      "package",
      "cube"
    ]
  },
  {
    "name": "brightness-contrast",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "images"
    ],
    "unicode": "e043",
    "id": 1018,
    "tags": [
      "brightness",
      "contrast",
      "images"
    ]
  },
  {
    "name": "brush",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "images"
    ],
    "unicode": "e044",
    "id": 1019,
    "tags": [
      "brush",
      "images",
      "paint",
      "draw",
      "art"
    ]
  },
  {
    "name": "building-blocks",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e045",
    "id": 1020,
    "tags": [
      "building",
      "blocks",
      "editing"
    ]
  },
  {
    "name": "bus",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "misc"
    ],
    "unicode": "e046",
    "id": 1021,
    "tags": [
      "vehicles",
      "automobile",
      "public transit",
      "transportation",
      "commuter",
      "traveling",
      "places",
      "locations"
    ]
  },
  {
    "name": "non-recurrence",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e047",
    "id": 649,
    "tags": [
      "non",
      "recurrence",
      "actions"
    ]
  },
  {
    "name": "display-block",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "css",
      "layout"
    ],
    "unicode": "e048",
    "id": 72,
    "tags": [
      "display",
      "block",
      "css",
      "layout"
    ]
  },
  {
    "name": "display-flex",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "css",
      "layout"
    ],
    "unicode": "e049",
    "id": 73,
    "tags": [
      "display",
      "flex",
      "css",
      "layout"
    ]
  },
  {
    "name": "display-inline-flex",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "css",
      "layout"
    ],
    "unicode": "e04a",
    "id": 74,
    "tags": [
      "display",
      "inline",
      "flex",
      "css",
      "layout"
    ]
  },
  {
    "name": "button",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e04b",
    "id": 1022,
    "tags": [
      "button",
      "editing",
      "click",
      "action",
      "control"
    ]
  },
  {
    "name": "file-report",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "files-and-folders"
    ],
    "unicode": "e04c",
    "id": 76,
    "tags": [
      "file",
      "report",
      "files-and-folders",
      "document",
      "page",
      "paper"
    ]
  },
  {
    "name": "calculator",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e04d",
    "id": 1023,
    "tags": [
      "addition",
      "sum",
      "subtraction",
      "difference",
      "multiply",
      "multiplication",
      "product",
      "divide",
      "division",
      "divisor",
      "dividend",
      "quotient",
      "equals",
      "equality",
      "mathematics",
      "arithmetic",
      "+",
      "-",
      "Â±",
      "Ã—",
      "Ã·",
      "="
    ]
  },
  {
    "name": "calendar-date",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e04e",
    "id": 1024,
    "tags": [
      "calendar",
      "date",
      "editing",
      "schedule",
      "event"
    ]
  },
  {
    "name": "calendar",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e04f",
    "id": 1025,
    "tags": [
      "dates",
      "times",
      "events",
      "schedule",
      "12"
    ]
  },
  {
    "name": "camera",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "images"
    ],
    "unicode": "e050",
    "id": 1026,
    "tags": [
      "photography",
      "pictures",
      "lens"
    ]
  },
  {
    "name": "cancel",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e051",
    "id": 1027,
    "tags": [
      "cancel",
      "actions"
    ]
  },
  {
    "name": "letter-space",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "css",
      "text-formatting"
    ],
    "unicode": "e052",
    "id": 82,
    "tags": [
      "letter",
      "space",
      "css",
      "text-formatting"
    ]
  },
  {
    "name": "line-height",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "css",
      "text-formatting"
    ],
    "unicode": "e053",
    "id": 83,
    "tags": [
      "line",
      "height",
      "css",
      "text-formatting",
      "chart",
      "graph",
      "trend"
    ]
  },
  {
    "name": "list-latin-big",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "css",
      "list"
    ],
    "unicode": "e054",
    "id": 84,
    "tags": [
      "list",
      "latin",
      "big",
      "css",
      "bullet",
      "items",
      "menu"
    ]
  },
  {
    "name": "list-latin-small",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "css",
      "list"
    ],
    "unicode": "e055",
    "id": 85,
    "tags": [
      "list",
      "latin",
      "small",
      "css",
      "bullet",
      "items",
      "menu"
    ]
  },
  {
    "name": "car",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "misc"
    ],
    "unicode": "e056",
    "id": 1028,
    "tags": [
      "cars",
      "vehicles",
      "automobile",
      "transit",
      "transportation",
      "traveling"
    ]
  },
  {
    "name": "caret-alt-down",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "navigation"
    ],
    "unicode": "e057",
    "id": 1029,
    "tags": [
      "caret",
      "alt",
      "down",
      "navigation",
      "arrow",
      "dropdown",
      "expand"
    ]
  },
  {
    "name": "caret-alt-expand",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "navigation"
    ],
    "unicode": "e058",
    "id": 1030,
    "tags": [
      "caret",
      "alt",
      "expand",
      "navigation",
      "arrow",
      "dropdown"
    ]
  },
  {
    "name": "caret-alt-left",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "navigation"
    ],
    "unicode": "e059",
    "id": 1031,
    "tags": [
      "caret",
      "alt",
      "left",
      "navigation",
      "arrow",
      "dropdown",
      "expand"
    ]
  },
  {
    "name": "caret-alt-right",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "navigation"
    ],
    "unicode": "e05a",
    "id": 1032,
    "tags": [
      "caret",
      "alt",
      "right",
      "navigation",
      "arrow",
      "dropdown",
      "expand"
    ]
  },
  {
    "name": "caret-alt-to-bottom",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "navigation"
    ],
    "unicode": "e05b",
    "id": 1033,
    "tags": [
      "caret",
      "alt",
      "to",
      "bottom",
      "navigation",
      "arrow",
      "dropdown",
      "expand"
    ]
  },
  {
    "name": "caret-alt-to-left",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "navigation"
    ],
    "unicode": "e05c",
    "id": 1034,
    "tags": [
      "caret",
      "alt",
      "to",
      "left",
      "navigation",
      "arrow",
      "dropdown",
      "expand"
    ]
  },
  {
    "name": "caret-alt-to-right",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "navigation"
    ],
    "unicode": "e05d",
    "id": 1035,
    "tags": [
      "caret",
      "alt",
      "to",
      "right",
      "navigation",
      "arrow",
      "dropdown",
      "expand"
    ]
  },
  {
    "name": "outline-offset",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "css"
    ],
    "unicode": "e05e",
    "id": 94,
    "tags": [
      "outline",
      "offset",
      "css"
    ]
  },
  {
    "name": "outline-width",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "css"
    ],
    "unicode": "e05f",
    "id": 95,
    "tags": [
      "outline",
      "width",
      "css"
    ]
  },
  {
    "name": "padding-bottom",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "css",
      "layout"
    ],
    "unicode": "e060",
    "id": 96,
    "tags": [
      "padding",
      "bottom",
      "css",
      "layout"
    ]
  },
  {
    "name": "padding-left",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "css",
      "layout"
    ],
    "unicode": "e061",
    "id": 97,
    "tags": [
      "padding",
      "left",
      "css",
      "layout"
    ]
  },
  {
    "name": "padding-right",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "css",
      "layout"
    ],
    "unicode": "e062",
    "id": 98,
    "tags": [
      "padding",
      "right",
      "css",
      "layout"
    ]
  },
  {
    "name": "padding-top",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "css",
      "layout"
    ],
    "unicode": "e063",
    "id": 99,
    "tags": [
      "padding",
      "top",
      "css",
      "layout"
    ]
  },
  {
    "name": "padding",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "css",
      "layout"
    ],
    "unicode": "e064",
    "id": 100,
    "tags": [
      "padding",
      "css",
      "layout"
    ]
  },
  {
    "name": "position-bottom",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "css"
    ],
    "unicode": "e065",
    "id": 101,
    "tags": [
      "position",
      "bottom",
      "css"
    ]
  },
  {
    "name": "position-left",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "css"
    ],
    "unicode": "e066",
    "id": 102,
    "tags": [
      "position",
      "left",
      "css"
    ]
  },
  {
    "name": "position-right",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "css"
    ],
    "unicode": "e067",
    "id": 103,
    "tags": [
      "position",
      "right",
      "css"
    ]
  },
  {
    "name": "position-top",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "css"
    ],
    "unicode": "e068",
    "id": 104,
    "tags": [
      "position",
      "top",
      "css"
    ]
  },
  {
    "name": "caret-alt-to-top",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "navigation"
    ],
    "unicode": "e069",
    "id": 1036,
    "tags": [
      "caret",
      "alt",
      "to",
      "top",
      "navigation",
      "arrow",
      "dropdown",
      "expand"
    ]
  },
  {
    "name": "caret-alt-up",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "navigation"
    ],
    "unicode": "e06a",
    "id": 1037,
    "tags": [
      "caret",
      "alt",
      "up",
      "navigation",
      "arrow",
      "dropdown",
      "expand"
    ]
  },
  {
    "name": "caret-bl",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "navigation"
    ],
    "unicode": "e06b",
    "id": 1038,
    "tags": [
      "caret",
      "bl",
      "navigation",
      "arrow",
      "dropdown",
      "expand"
    ]
  },
  {
    "name": "caret-br",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "navigation"
    ],
    "unicode": "e06c",
    "id": 1039,
    "tags": [
      "caret",
      "br",
      "navigation",
      "arrow",
      "dropdown",
      "expand"
    ]
  },
  {
    "name": "caret-double-alt-down",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "navigation"
    ],
    "unicode": "e06d",
    "id": 1040,
    "tags": [
      "caret",
      "double",
      "alt",
      "down",
      "navigation",
      "arrow",
      "dropdown",
      "expand"
    ]
  },
  {
    "name": "caret-double-alt-left",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "navigation"
    ],
    "unicode": "e06e",
    "id": 1041,
    "tags": [
      "caret",
      "double",
      "alt",
      "left",
      "navigation",
      "arrow",
      "dropdown",
      "expand"
    ]
  },
  {
    "name": "data-sds",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "files-and-folders"
    ],
    "unicode": "e06f",
    "id": 645,
    "tags": [
      "data",
      "sds",
      "files-and-folders"
    ]
  },
  {
    "name": "caret-double-alt-right",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "navigation"
    ],
    "unicode": "e070",
    "id": 1042,
    "tags": [
      "caret",
      "double",
      "alt",
      "right",
      "navigation",
      "arrow",
      "dropdown",
      "expand"
    ]
  },
  {
    "name": "caret-double-alt-up",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "navigation"
    ],
    "unicode": "e071",
    "id": 1043,
    "tags": [
      "caret",
      "double",
      "alt",
      "up",
      "navigation",
      "arrow",
      "dropdown",
      "expand"
    ]
  },
  {
    "name": "caret-tl",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "navigation"
    ],
    "unicode": "e072",
    "id": 1044,
    "tags": [
      "caret",
      "tl",
      "navigation",
      "arrow",
      "dropdown",
      "expand"
    ]
  },
  {
    "name": "caret-tr",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "navigation"
    ],
    "unicode": "e073",
    "id": 1045,
    "tags": [
      "caret",
      "tr",
      "navigation",
      "arrow",
      "dropdown",
      "expand"
    ]
  },
  {
    "name": "cart",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e074",
    "id": 1046,
    "tags": [
      "cart",
      "actions",
      "shopping",
      "basket",
      "buy"
    ]
  },
  {
    "name": "categorize",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "navigation"
    ],
    "unicode": "e075",
    "id": 1047,
    "tags": [
      "categorize",
      "navigation"
    ]
  },
  {
    "name": "chart-doughnut",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "charts"
    ],
    "unicode": "e076",
    "id": 1048,
    "tags": [
      "chart",
      "doughnut",
      "charts",
      "graph",
      "analytics",
      "statistics"
    ]
  },
  {
    "name": "chart-pie",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "charts"
    ],
    "unicode": "e077",
    "id": 1049,
    "tags": [
      "graphs",
      "graphing",
      "charts",
      "statistics",
      "circle",
      "analyze",
      "analysis"
    ]
  },
  {
    "name": "chart-radar",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "charts"
    ],
    "unicode": "e078",
    "id": 1050,
    "tags": [
      "chart",
      "radar",
      "charts",
      "graph",
      "analytics",
      "statistics"
    ]
  },
  {
    "name": "chart-scatter",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "charts"
    ],
    "unicode": "e079",
    "id": 1051,
    "tags": [
      "graphs",
      "graphing",
      "charts",
      "statistics",
      "analyze",
      "analysis"
    ]
  },
  {
    "name": "check-circle",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e07a",
    "id": 1052,
    "tags": [
      "todo",
      "to-do",
      "task",
      "list",
      "checkbox",
      "round",
      "ok",
      "done"
    ]
  },
  {
    "name": "check",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e07b",
    "id": 1053,
    "tags": [
      "todo",
      "to-do",
      "task",
      "list",
      "checkbox",
      "ok",
      "done"
    ]
  },
  {
    "name": "font-grow",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "text-formatting"
    ],
    "unicode": "e07c",
    "id": 660,
    "tags": [
      "font",
      "grow",
      "text-formatting"
    ]
  },
  {
    "name": "font-shrink",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "text-formatting"
    ],
    "unicode": "e07d",
    "id": 662,
    "tags": [
      "font",
      "shrink",
      "text-formatting"
    ]
  },
  {
    "name": "text-overflow",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "text-formatting"
    ],
    "unicode": "e07e",
    "id": 664,
    "tags": [
      "text",
      "overflow",
      "text-formatting",
      "typography",
      "font",
      "writing"
    ]
  },
  {
    "name": "checkbox-checked",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "toggle"
    ],
    "unicode": "e07f",
    "id": 1054,
    "tags": [
      "checkbox",
      "checked",
      "toggle",
      "check",
      "form"
    ]
  },
  {
    "name": "checkbox-indeterminate",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "toggle"
    ],
    "unicode": "e080",
    "id": 1055,
    "tags": [
      "checkbox",
      "indeterminate",
      "toggle",
      "check",
      "form"
    ]
  },
  {
    "name": "text-clip",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "text-formatting"
    ],
    "unicode": "e081",
    "id": 670,
    "tags": [
      "text",
      "clip",
      "text-formatting",
      "typography",
      "font",
      "writing"
    ]
  },
  {
    "name": "checkbox",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "toggle"
    ],
    "unicode": "e082",
    "id": 1056,
    "tags": [
      "checkbox",
      "toggle",
      "check",
      "form"
    ]
  },
  {
    "name": "border-type",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "borders"
    ],
    "unicode": "e083",
    "id": 674,
    "tags": [
      "border",
      "type",
      "borders"
    ]
  },
  {
    "name": "chevron-double-down",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "arrows"
    ],
    "unicode": "e084",
    "id": 1057,
    "tags": [
      "chevron",
      "double",
      "down",
      "arrows",
      "arrow",
      "direction",
      "caret"
    ]
  },
  {
    "name": "chevron-double-left",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "arrows"
    ],
    "unicode": "e085",
    "id": 1058,
    "tags": [
      "chevron",
      "double",
      "left",
      "arrows",
      "arrow",
      "direction",
      "caret"
    ]
  },
  {
    "name": "chevron-double-right",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "arrows"
    ],
    "unicode": "e086",
    "id": 1059,
    "tags": [
      "chevron",
      "double",
      "right",
      "arrows",
      "arrow",
      "direction",
      "caret"
    ]
  },
  {
    "name": "chevron-double-up",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "arrows"
    ],
    "unicode": "e087",
    "id": 1060,
    "tags": [
      "chevron",
      "double",
      "up",
      "arrows",
      "arrow",
      "direction",
      "caret"
    ]
  },
  {
    "name": "chevron-down",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "navigation",
      "arrows"
    ],
    "unicode": "e088",
    "id": 1061,
    "tags": [
      "chevron",
      "down",
      "navigation",
      "arrows",
      "arrow",
      "direction",
      "caret"
    ]
  },
  {
    "name": "chevron-left",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "navigation",
      "arrows"
    ],
    "unicode": "e089",
    "id": 1062,
    "tags": [
      "chevron",
      "left",
      "navigation",
      "arrows",
      "arrow",
      "direction",
      "caret"
    ]
  },
  {
    "name": "chevron-right",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "navigation",
      "arrows"
    ],
    "unicode": "e08a",
    "id": 1063,
    "tags": [
      "chevron",
      "right",
      "navigation",
      "arrows",
      "arrow",
      "direction",
      "caret"
    ]
  },
  {
    "name": "chevron-up",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "navigation",
      "arrows"
    ],
    "unicode": "e08b",
    "id": 1064,
    "tags": [
      "chevron",
      "up",
      "navigation",
      "arrows",
      "arrow",
      "direction",
      "caret"
    ]
  },
  {
    "name": "circle-shape",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e08c",
    "id": 1065,
    "tags": [
      "circle",
      "shape",
      "editing",
      "form",
      "polygon",
      "geometry"
    ]
  },
  {
    "name": "circle",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "toggle"
    ],
    "unicode": "e08d",
    "id": 1066,
    "tags": [
      "round",
      "shapes",
      "polygons"
    ]
  },
  {
    "name": "clear-css",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e08e",
    "id": 1067,
    "tags": [
      "clear",
      "css",
      "editing",
      "style",
      "design",
      "web"
    ]
  },
  {
    "name": "clipboard-code",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e08f",
    "id": 1068,
    "tags": [
      "clipboard",
      "code",
      "editing",
      "programming",
      "developer",
      "html"
    ]
  },
  {
    "name": "clipboard-html",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e090",
    "id": 1069,
    "tags": [
      "clipboard",
      "html",
      "editing",
      "web",
      "code",
      "markup"
    ]
  },
  {
    "name": "clipboard-markdown",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e091",
    "id": 1070,
    "tags": [
      "clipboard",
      "markdown",
      "editing"
    ]
  },
  {
    "name": "clipboard-text",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e092",
    "id": 1071,
    "tags": [
      "copy",
      "copied",
      "checklist"
    ]
  },
  {
    "name": "clipboard-word-alt",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e093",
    "id": 1072,
    "tags": [
      "clipboard",
      "word",
      "alt",
      "editing",
      "document",
      "doc",
      "text"
    ]
  },
  {
    "name": "free-text",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e094",
    "id": 692,
    "tags": [
      "free",
      "text",
      "editing",
      "typography",
      "font",
      "writing"
    ]
  },
  {
    "name": "clipboard-word",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e095",
    "id": 1073,
    "tags": [
      "clipboard",
      "word",
      "editing",
      "document",
      "doc",
      "text"
    ]
  },
  {
    "name": "clipboard",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e096",
    "id": 1074,
    "tags": [
      "copy",
      "copied",
      "checklist"
    ]
  },
  {
    "name": "clock-arrow-rotate",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e097",
    "id": 1075,
    "tags": [
      "clock",
      "arrow",
      "rotate",
      "actions",
      "time",
      "timer",
      "schedule",
      "direction",
      "navigate",
      "pointer",
      "turn",
      "spin",
      "orientation"
    ]
  },
  {
    "name": "clock",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e098",
    "id": 1076,
    "tags": [
      "times",
      "timer",
      "alarm",
      "schedule",
      "events",
      "watch"
    ]
  },
  {
    "name": "closed-captions",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "media"
    ],
    "unicode": "e099",
    "id": 1077,
    "tags": [
      "closed",
      "captions",
      "media"
    ]
  },
  {
    "name": "cloud",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "files-and-folders"
    ],
    "unicode": "e09a",
    "id": 1078,
    "tags": [
      "serverless",
      "backup",
      "storage",
      "meteorology",
      "cloudy",
      "overcast"
    ]
  },
  {
    "name": "code-snippet",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e09b",
    "id": 1079,
    "tags": [
      "code",
      "snippet",
      "editing",
      "programming",
      "developer",
      "html"
    ]
  },
  {
    "name": "code",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "files-and-folders"
    ],
    "unicode": "e09c",
    "id": 1080,
    "tags": [
      "angle brackets",
      "angle braces",
      "snippets"
    ]
  },
  {
    "name": "col-resize",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "navigation",
      "arrows"
    ],
    "unicode": "e09d",
    "id": 1081,
    "tags": [
      "col",
      "resize",
      "navigation",
      "arrows",
      "scale",
      "expand",
      "shrink"
    ]
  },
  {
    "name": "columns",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "layout"
    ],
    "unicode": "e09e",
    "id": 1082,
    "tags": [
      "2",
      "shapes",
      "polygons",
      "box",
      "stack",
      "list",
      "table",
      "cards"
    ]
  },
  {
    "name": "comment-remove",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e09f",
    "id": 1083,
    "tags": [
      "comment",
      "remove",
      "editing",
      "delete",
      "minus",
      "subtract"
    ]
  },
  {
    "name": "comment",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e0a0",
    "id": 1084,
    "tags": [
      "comment",
      "editing"
    ]
  },
  {
    "name": "comments-remove",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e0a1",
    "id": 1085,
    "tags": [
      "comments",
      "remove",
      "editing",
      "delete",
      "minus",
      "subtract"
    ]
  },
  {
    "name": "concrete-truck",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "misc"
    ],
    "unicode": "e0a2",
    "id": 1086,
    "tags": [
      "concrete",
      "truck",
      "misc"
    ]
  },
  {
    "name": "connector",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e0a3",
    "id": 1087,
    "tags": [
      "connector",
      "actions"
    ]
  },
  {
    "name": "convert-lowercase",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "text-formatting"
    ],
    "unicode": "e0a4",
    "id": 1088,
    "tags": [
      "convert",
      "lowercase",
      "text-formatting"
    ]
  },
  {
    "name": "convert-uppercase",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "text-formatting"
    ],
    "unicode": "e0a5",
    "id": 1089,
    "tags": [
      "convert",
      "uppercase",
      "text-formatting"
    ]
  },
  {
    "name": "copy-format",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e0a6",
    "id": 1090,
    "tags": [
      "copy",
      "format",
      "editing",
      "duplicate",
      "clipboard"
    ]
  },
  {
    "name": "copy",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e0a7",
    "id": 1091,
    "tags": [
      "duplicated",
      "copied",
      "clipboard"
    ]
  },
  {
    "name": "crop",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "images"
    ],
    "unicode": "e0a8",
    "id": 1092,
    "tags": [
      "photography",
      "clip",
      "screenshots"
    ]
  },
  {
    "name": "cs",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "files-and-folders"
    ],
    "unicode": "e0a9",
    "id": 1093,
    "tags": [
      "cs",
      "files-and-folders"
    ]
  },
  {
    "name": "csproj",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "files-and-folders"
    ],
    "unicode": "e0aa",
    "id": 1094,
    "tags": [
      "csproj",
      "files-and-folders"
    ]
  },
  {
    "name": "css",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "files-and-folders"
    ],
    "unicode": "e0ab",
    "id": 1095,
    "tags": [
      "css",
      "files-and-folders",
      "style",
      "design",
      "web"
    ]
  },
  {
    "name": "cube",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e0ac",
    "id": 1096,
    "tags": [
      "square",
      "box",
      "3d",
      "volume",
      "blocks"
    ]
  },
  {
    "name": "custom-format",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e0ad",
    "id": 1097,
    "tags": [
      "custom",
      "format",
      "editing"
    ]
  },
  {
    "name": "custom-icon",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e0ae",
    "id": 1098,
    "tags": [
      "custom",
      "icon",
      "editing"
    ]
  },
  {
    "name": "cut",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e0af",
    "id": 1099,
    "tags": [
      "cut",
      "editing",
      "scissors"
    ]
  },
  {
    "name": "data-ods",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "files-and-folders"
    ],
    "unicode": "e0b0",
    "id": 1100,
    "tags": [
      "data",
      "ods",
      "files-and-folders"
    ]
  },
  {
    "name": "data",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "files-and-folders"
    ],
    "unicode": "e0b1",
    "id": 1101,
    "tags": [
      "data",
      "files-and-folders"
    ]
  },
  {
    "name": "decision",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "misc"
    ],
    "unicode": "e0b2",
    "id": 1102,
    "tags": [
      "decision",
      "misc"
    ]
  },
  {
    "name": "decrease-horizontal-spacing",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e0b3",
    "id": 1103,
    "tags": [
      "decrease",
      "horizontal",
      "spacing",
      "editing"
    ]
  },
  {
    "name": "decrease-vertical-spacing",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e0b4",
    "id": 1104,
    "tags": [
      "decrease",
      "vertical",
      "spacing",
      "editing"
    ]
  },
  {
    "name": "delicious",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "social"
    ],
    "unicode": "e0b5",
    "id": 1105,
    "tags": [
      "delicious",
      "social"
    ]
  },
  {
    "name": "detail-section",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "files-and-folders"
    ],
    "unicode": "e0b6",
    "id": 1106,
    "tags": [
      "detail",
      "section",
      "files-and-folders"
    ]
  },
  {
    "name": "digg",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "social"
    ],
    "unicode": "e0b7",
    "id": 1107,
    "tags": [
      "digg",
      "social"
    ]
  },
  {
    "name": "dimensions",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e0b8",
    "id": 1108,
    "tags": [
      "dimensions",
      "editing"
    ]
  },
  {
    "name": "directions",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "misc"
    ],
    "unicode": "e0b9",
    "id": 1109,
    "tags": [
      "directions",
      "misc"
    ]
  },
  {
    "name": "display-inline-block",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "css",
      "layout"
    ],
    "unicode": "e0ba",
    "id": 1110,
    "tags": [
      "display",
      "inline",
      "block",
      "css",
      "layout"
    ]
  },
  {
    "name": "distance",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e0bb",
    "id": 1111,
    "tags": [
      "distance",
      "editing"
    ]
  },
  {
    "name": "div",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "text-formatting"
    ],
    "unicode": "e0bc",
    "id": 1112,
    "tags": [
      "div",
      "text-formatting"
    ]
  },
  {
    "name": "divide",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e0bd",
    "id": 1113,
    "tags": [
      "division",
      "divisor",
      "dividend",
      "quotient",
      "mathematics",
      "arithmetic",
      "calculator"
    ]
  },
  {
    "name": "document-manager",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e0be",
    "id": 1114,
    "tags": [
      "document",
      "manager",
      "editing"
    ]
  },
  {
    "name": "dollar",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e0bf",
    "id": 1115,
    "tags": [
      "dollar",
      "editing",
      "money",
      "currency",
      "price",
      "payment"
    ]
  },
  {
    "name": "download",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e0c0",
    "id": 1116,
    "tags": [
      "saved",
      "saving",
      "archived",
      "archiving",
      "archival",
      "downloaded",
      "downloading",
      "hard drive",
      "disk"
    ]
  },
  {
    "name": "draw-free",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e0c1",
    "id": 1117,
    "tags": [
      "draw",
      "free",
      "editing"
    ]
  },
  {
    "name": "dribbble",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "social"
    ],
    "unicode": "e0c2",
    "id": 1118,
    "tags": [
      "dribbble",
      "social"
    ]
  },
  {
    "name": "droplet-slash",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e0c3",
    "id": 1119,
    "tags": [
      "droplet",
      "slash",
      "editing"
    ]
  },
  {
    "name": "droplet-slider",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "images"
    ],
    "unicode": "e0c4",
    "id": 1120,
    "tags": [
      "droplet",
      "slider",
      "images",
      "range",
      "control",
      "adjust"
    ]
  },
  {
    "name": "droplet",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "images"
    ],
    "unicode": "e0c5",
    "id": 1121,
    "tags": [
      "droplet",
      "images"
    ]
  },
  {
    "name": "edit-annotations",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e0c6",
    "id": 1122,
    "tags": [
      "edit",
      "annotations",
      "editing",
      "write",
      "modify",
      "pencil"
    ]
  },
  {
    "name": "edit-tools",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e0c7",
    "id": 1123,
    "tags": [
      "edit",
      "tools",
      "editing",
      "write",
      "modify",
      "pencil"
    ]
  },
  {
    "name": "envelope-link",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e0c8",
    "id": 1124,
    "tags": [
      "envelope",
      "link",
      "editing",
      "chain",
      "url",
      "hyperlink"
    ]
  },
  {
    "name": "envelope",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "social"
    ],
    "unicode": "e0c9",
    "id": 1125,
    "tags": [
      "mail",
      "email",
      "send",
      "sent",
      "message",
      "post",
      "letter"
    ]
  },
  {
    "name": "equal",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e0ca",
    "id": 1126,
    "tags": [
      "equal",
      "actions",
      "same",
      "match",
      "balance"
    ]
  },
  {
    "name": "exclamation-circle",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "notifications"
    ],
    "unicode": "e0cb",
    "id": 1127,
    "tags": [
      "exclamation",
      "circle",
      "notifications"
    ]
  },
  {
    "name": "border-radius-undefined",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e0cc",
    "id": 754,
    "tags": [
      "border",
      "radius",
      "undefined",
      "editing"
    ]
  },
  {
    "name": "border-width",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e0cd",
    "id": 755,
    "tags": [
      "border",
      "width",
      "editing"
    ]
  },
  {
    "name": "exe",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "files-and-folders"
    ],
    "unicode": "e0ce",
    "id": 1128,
    "tags": [
      "exe",
      "files-and-folders"
    ]
  },
  {
    "name": "combobox",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e0cf",
    "id": 757,
    "tags": [
      "combobox",
      "editing"
    ]
  },
  {
    "name": "export",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e0d0",
    "id": 1129,
    "tags": [
      "share",
      "send to",
      "arrows"
    ]
  },
  {
    "name": "eye-slash",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e0d1",
    "id": 1130,
    "tags": [
      "visible",
      "hidden",
      "show",
      "hide",
      "visibility",
      "view",
      "invisible",
      "eyelashes",
      "disabled",
      "private"
    ]
  },
  {
    "name": "eye",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e0d2",
    "id": 1131,
    "tags": [
      "visible",
      "hidden",
      "show",
      "hide",
      "visibility",
      "view"
    ]
  },
  {
    "name": "dropdown",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e0d3",
    "id": 761,
    "tags": [
      "dropdown",
      "editing"
    ]
  },
  {
    "name": "eyedropper",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e0d4",
    "id": 1132,
    "tags": [
      "colors",
      "color picker",
      "sample",
      "arts"
    ]
  },
  {
    "name": "facebook",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "social"
    ],
    "unicode": "e0d5",
    "id": 1133,
    "tags": [
      "facebook",
      "social"
    ]
  },
  {
    "name": "insert-free-text",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e0d6",
    "id": 764,
    "tags": [
      "insert",
      "free",
      "text",
      "editing",
      "typography",
      "font",
      "writing"
    ]
  },
  {
    "name": "file-add",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "files-and-folders"
    ],
    "unicode": "e0d7",
    "id": 1134,
    "tags": [
      "file",
      "add",
      "files-and-folders",
      "document",
      "page",
      "paper",
      "plus",
      "create",
      "new"
    ]
  },
  {
    "name": "file-ascx",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "files-and-folders"
    ],
    "unicode": "e0d8",
    "id": 1135,
    "tags": [
      "file",
      "ascx",
      "files-and-folders",
      "document",
      "page",
      "paper"
    ]
  },
  {
    "name": "file-audio",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "files-and-folders"
    ],
    "unicode": "e0d9",
    "id": 1136,
    "tags": [
      "documents",
      "music",
      "sound"
    ]
  },
  {
    "name": "file-bac",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "files-and-folders"
    ],
    "unicode": "e0da",
    "id": 1137,
    "tags": [
      "file",
      "bac",
      "files-and-folders",
      "document",
      "page",
      "paper"
    ]
  },
  {
    "name": "file-csv",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "files-and-folders"
    ],
    "unicode": "e0db",
    "id": 1138,
    "tags": [
      "documents",
      "data"
    ]
  },
  {
    "name": "file-data",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "files-and-folders"
    ],
    "unicode": "e0dc",
    "id": 1139,
    "tags": [
      "file",
      "data",
      "files-and-folders",
      "document",
      "page",
      "paper"
    ]
  },
  {
    "name": "file-error",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "files-and-folders"
    ],
    "unicode": "e0dd",
    "id": 1140,
    "tags": [
      "file",
      "error",
      "files-and-folders",
      "document",
      "page",
      "paper",
      "problem",
      "issue",
      "bug"
    ]
  },
  {
    "name": "file-excel",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "files-and-folders"
    ],
    "unicode": "e0de",
    "id": 1141,
    "tags": [
      "file",
      "excel",
      "files-and-folders",
      "document",
      "page",
      "paper",
      "spreadsheet",
      "xls",
      "csv"
    ]
  },
  {
    "name": "file-image",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "files-and-folders"
    ],
    "unicode": "e0df",
    "id": 1142,
    "tags": [
      "documents",
      "pictures",
      "photograph"
    ]
  },
  {
    "name": "file-pdf",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "files-and-folders"
    ],
    "unicode": "e0e0",
    "id": 1143,
    "tags": [
      "documents",
      "files",
      "acrobat"
    ]
  },
  {
    "name": "file-ppt",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "files-and-folders"
    ],
    "unicode": "e0e1",
    "id": 1144,
    "tags": [
      "documents",
      "powerpoint",
      "microsoft"
    ]
  },
  {
    "name": "file-programming",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "files-and-folders"
    ],
    "unicode": "e0e2",
    "id": 1145,
    "tags": [
      "file",
      "programming",
      "files-and-folders",
      "document",
      "page",
      "paper"
    ]
  },
  {
    "name": "file-txt",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "files-and-folders"
    ],
    "unicode": "e0e3",
    "id": 1146,
    "tags": [
      "documents"
    ]
  },
  {
    "name": "file-typescript",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "files-and-folders"
    ],
    "unicode": "e0e4",
    "id": 1147,
    "tags": [
      "file",
      "typescript",
      "files-and-folders",
      "document",
      "page",
      "paper"
    ]
  },
  {
    "name": "file-video",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "files-and-folders"
    ],
    "unicode": "e0e5",
    "id": 1148,
    "tags": [
      "documents",
      "movie"
    ]
  },
  {
    "name": "file-word",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "files-and-folders"
    ],
    "unicode": "e0e6",
    "id": 1149,
    "tags": [
      "file",
      "word",
      "files-and-folders",
      "document",
      "page",
      "paper",
      "doc",
      "text"
    ]
  },
  {
    "name": "file-zip",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "files-and-folders"
    ],
    "unicode": "e0e7",
    "id": 1150,
    "tags": [
      "documents",
      "archive",
      "compression"
    ]
  },
  {
    "name": "file",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "files-and-folders"
    ],
    "unicode": "e0e8",
    "id": 1151,
    "tags": [
      "documents",
      "files",
      "save",
      "write",
      "page"
    ]
  },
  {
    "name": "film",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "files-and-folders"
    ],
    "unicode": "e0e9",
    "id": 1152,
    "tags": [
      "film",
      "files-and-folders"
    ]
  },
  {
    "name": "filter-clear",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e0ea",
    "id": 1153,
    "tags": [
      "filter",
      "clear",
      "actions",
      "funnel",
      "sieve"
    ]
  },
  {
    "name": "filter",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e0eb",
    "id": 1154,
    "tags": [
      "filter",
      "actions",
      "funnel",
      "sieve"
    ]
  },
  {
    "name": "flip-horizontal",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "images"
    ],
    "unicode": "e0ec",
    "id": 1155,
    "tags": [
      "mirror",
      "rotate",
      "invert"
    ]
  },
  {
    "name": "flip-vertical",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "images"
    ],
    "unicode": "e0ed",
    "id": 1156,
    "tags": [
      "mirror",
      "rotate",
      "invert"
    ]
  },
  {
    "name": "folder-add",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "files-and-folders"
    ],
    "unicode": "e0ee",
    "id": 1157,
    "tags": [
      "folder",
      "add",
      "files-and-folders",
      "directory",
      "files",
      "plus",
      "create",
      "new"
    ]
  },
  {
    "name": "folder-more",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "files-and-folders"
    ],
    "unicode": "e0ef",
    "id": 1158,
    "tags": [
      "folder",
      "more",
      "files-and-folders",
      "directory",
      "files"
    ]
  },
  {
    "name": "folder-open",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "files-and-folders"
    ],
    "unicode": "e0f0",
    "id": 1159,
    "tags": [
      "directory",
      "directories",
      "files",
      "folders",
      "load"
    ]
  },
  {
    "name": "folder",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "files-and-folders"
    ],
    "unicode": "e0f1",
    "id": 1160,
    "tags": [
      "directory",
      "directories",
      "files",
      "folders"
    ]
  },
  {
    "name": "font-family",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "text-formatting"
    ],
    "unicode": "e0f2",
    "id": 1161,
    "tags": [
      "font",
      "family",
      "text-formatting"
    ]
  },
  {
    "name": "font-size",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "text-formatting"
    ],
    "unicode": "e0f3",
    "id": 1162,
    "tags": [
      "font",
      "size",
      "text-formatting"
    ]
  },
  {
    "name": "form",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e0f4",
    "id": 1163,
    "tags": [
      "form",
      "editing"
    ]
  },
  {
    "name": "format-code-block",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e0f5",
    "id": 1164,
    "tags": [
      "format",
      "code",
      "block",
      "editing",
      "programming",
      "developer",
      "html"
    ]
  },
  {
    "name": "formula-fx",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e0f6",
    "id": 1165,
    "tags": [
      "formula",
      "fx",
      "editing",
      "math",
      "equation",
      "calculate"
    ]
  },
  {
    "name": "forward",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "media"
    ],
    "unicode": "e0f7",
    "id": 1166,
    "tags": [
      "forward",
      "media",
      "next",
      "skip",
      "ahead"
    ]
  },
  {
    "name": "fullscreen-exit",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "media"
    ],
    "unicode": "e0f8",
    "id": 1167,
    "tags": [
      "fullscreen",
      "exit",
      "media"
    ]
  },
  {
    "name": "fullscreen",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "media"
    ],
    "unicode": "e0f9",
    "id": 1168,
    "tags": [
      "fullscreen",
      "media"
    ]
  },
  {
    "name": "gap-column",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "css",
      "layout"
    ],
    "unicode": "e0fa",
    "id": 1169,
    "tags": [
      "gap",
      "column",
      "css",
      "layout"
    ]
  },
  {
    "name": "gap-row",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "css",
      "layout"
    ],
    "unicode": "e0fb",
    "id": 1170,
    "tags": [
      "gap",
      "row",
      "css",
      "layout"
    ]
  },
  {
    "name": "gauge-linear",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "charts"
    ],
    "unicode": "e0fc",
    "id": 1171,
    "tags": [
      "gauge",
      "linear",
      "charts",
      "meter",
      "dial",
      "indicator"
    ]
  },
  {
    "name": "gauge-radial",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "charts"
    ],
    "unicode": "e0fd",
    "id": 1172,
    "tags": [
      "gauge",
      "radial",
      "charts",
      "meter",
      "dial",
      "indicator"
    ]
  },
  {
    "name": "gear",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e0fe",
    "id": 1173,
    "tags": [
      "8",
      "settings",
      "setup",
      "preferences",
      "cogs",
      "gears",
      "machinery",
      "mechanical"
    ]
  },
  {
    "name": "gears",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e0ff",
    "id": 1174,
    "tags": [
      "gears",
      "actions"
    ]
  },
  {
    "name": "globe-unlink",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e100",
    "id": 1175,
    "tags": [
      "globe",
      "unlink",
      "editing",
      "world",
      "earth",
      "international",
      "web",
      "break",
      "disconnect"
    ]
  },
  {
    "name": "google-plus",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "social"
    ],
    "unicode": "e101",
    "id": 1176,
    "tags": [
      "google",
      "plus",
      "social",
      "add",
      "create",
      "positive"
    ]
  },
  {
    "name": "google",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "social"
    ],
    "unicode": "e102",
    "id": 1177,
    "tags": [
      "google",
      "social"
    ]
  },
  {
    "name": "graph",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "charts"
    ],
    "unicode": "e103",
    "id": 1178,
    "tags": [
      "nodes",
      "tree"
    ]
  },
  {
    "name": "grayscale",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "images"
    ],
    "unicode": "e104",
    "id": 1179,
    "tags": [
      "grayscale",
      "images"
    ]
  },
  {
    "name": "greater-or-equal",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e105",
    "id": 1180,
    "tags": [
      "greater",
      "or",
      "equal",
      "actions",
      "more",
      "larger",
      "above",
      "same",
      "match",
      "balance"
    ]
  },
  {
    "name": "grid",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "layout"
    ],
    "unicode": "e106",
    "id": 1181,
    "tags": [
      "grid",
      "layout",
      "tiles",
      "view"
    ]
  },
  {
    "name": "group-box",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e107",
    "id": 1182,
    "tags": [
      "group",
      "box",
      "editing",
      "combine",
      "merge",
      "collect",
      "container",
      "package",
      "cube"
    ]
  },
  {
    "name": "group-collection",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "files-and-folders"
    ],
    "unicode": "e108",
    "id": 1183,
    "tags": [
      "group",
      "collection",
      "files-and-folders",
      "combine",
      "merge",
      "collect"
    ]
  },
  {
    "name": "group",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "layout"
    ],
    "unicode": "e109",
    "id": 1184,
    "tags": [
      "group",
      "layout",
      "combine",
      "merge",
      "collect"
    ]
  },
  {
    "name": "h1",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "text-formatting"
    ],
    "unicode": "e10a",
    "id": 1185,
    "tags": [
      "h1",
      "text-formatting"
    ]
  },
  {
    "name": "h2",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "text-formatting"
    ],
    "unicode": "e10b",
    "id": 1186,
    "tags": [
      "h2",
      "text-formatting"
    ]
  },
  {
    "name": "h3",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "text-formatting"
    ],
    "unicode": "e10c",
    "id": 1187,
    "tags": [
      "h3",
      "text-formatting"
    ]
  },
  {
    "name": "h4",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "text-formatting"
    ],
    "unicode": "e10d",
    "id": 1188,
    "tags": [
      "h4",
      "text-formatting"
    ]
  },
  {
    "name": "h5",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "text-formatting"
    ],
    "unicode": "e10e",
    "id": 1189,
    "tags": [
      "h5",
      "text-formatting"
    ]
  },
  {
    "name": "h6",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "text-formatting"
    ],
    "unicode": "e10f",
    "id": 1190,
    "tags": [
      "h6",
      "text-formatting"
    ]
  },
  {
    "name": "hand",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e110",
    "id": 1191,
    "tags": [
      "pointers",
      "cursors",
      "emoji",
      "backhand"
    ]
  },
  {
    "name": "handle-drag-dots",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "layout"
    ],
    "unicode": "e111",
    "id": 1192,
    "tags": [
      "handle",
      "drag",
      "dots",
      "layout",
      "move",
      "reorder"
    ]
  },
  {
    "name": "handle-resize-alt",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "css",
      "editing"
    ],
    "unicode": "e112",
    "id": 1193,
    "tags": [
      "handle",
      "resize",
      "alt",
      "css",
      "editing",
      "scale",
      "expand",
      "shrink"
    ]
  },
  {
    "name": "handle-resize",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "css",
      "editing"
    ],
    "unicode": "e113",
    "id": 1194,
    "tags": [
      "handle",
      "resize",
      "css",
      "editing",
      "scale",
      "expand",
      "shrink"
    ]
  },
  {
    "name": "hd",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "media"
    ],
    "unicode": "e114",
    "id": 1195,
    "tags": [
      "hd",
      "media"
    ]
  },
  {
    "name": "headset",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "misc"
    ],
    "unicode": "e115",
    "id": 1196,
    "tags": [
      "music",
      "audio",
      "listening",
      "gaming",
      "voice chat",
      "microphone",
      "headphones",
      "support",
      "customer-service",
      "call-center"
    ]
  },
  {
    "name": "heart",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "toggle"
    ],
    "unicode": "e116",
    "id": 1197,
    "tags": [
      "wellness",
      "love",
      "healthy",
      "like",
      "favorites",
      "favorited",
      "suits",
      "cards",
      "gambling",
      "casino",
      "gaming",
      "emoji"
    ]
  },
  {
    "name": "hexagon-shape",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e117",
    "id": 1198,
    "tags": [
      "hexagon",
      "shape",
      "editing",
      "form",
      "polygon",
      "geometry"
    ]
  },
  {
    "name": "highlight-free",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e118",
    "id": 1199,
    "tags": [
      "highlight",
      "free",
      "editing"
    ]
  },
  {
    "name": "highlight",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e119",
    "id": 1200,
    "tags": [
      "highlight",
      "editing"
    ]
  },
  {
    "name": "home",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "navigation"
    ],
    "unicode": "e11a",
    "id": 1201,
    "tags": [
      "home",
      "navigation",
      "house",
      "main",
      "dashboard"
    ]
  },
  {
    "name": "hyperlink-open",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e11b",
    "id": 1202,
    "tags": [
      "hyperlink",
      "open",
      "actions"
    ]
  },
  {
    "name": "image-resize",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "images"
    ],
    "unicode": "e11c",
    "id": 1203,
    "tags": [
      "image",
      "resize",
      "images",
      "photo",
      "picture",
      "gallery",
      "scale",
      "expand",
      "shrink"
    ]
  },
  {
    "name": "image",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "images"
    ],
    "unicode": "e11d",
    "id": 1204,
    "tags": [
      "pictures",
      "photographs",
      "photography",
      "wallpapers",
      "gallery",
      "landscape"
    ]
  },
  {
    "name": "images",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "images"
    ],
    "unicode": "e11e",
    "id": 1205,
    "tags": [
      "pictures",
      "photographs",
      "photography",
      "wallpapers",
      "gallery",
      "landscape",
      "album"
    ]
  },
  {
    "name": "import",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e11f",
    "id": 1206,
    "tags": [
      "import",
      "actions",
      "upload",
      "load",
      "input"
    ]
  },
  {
    "name": "inbox",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "social"
    ],
    "unicode": "e120",
    "id": 1207,
    "tags": [
      "inbox",
      "social"
    ]
  },
  {
    "name": "increase-horizontal-spacing",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e121",
    "id": 1208,
    "tags": [
      "increase",
      "horizontal",
      "spacing",
      "editing"
    ]
  },
  {
    "name": "increase-vertical-spacing",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e122",
    "id": 1209,
    "tags": [
      "increase",
      "vertical",
      "spacing",
      "editing"
    ]
  },
  {
    "name": "indent",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "text-formatting"
    ],
    "unicode": "e123",
    "id": 1210,
    "tags": [
      "indent",
      "text-formatting",
      "tab",
      "margin",
      "offset"
    ]
  },
  {
    "name": "industrial-vehicle",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "misc"
    ],
    "unicode": "e124",
    "id": 1211,
    "tags": [
      "industrial",
      "vehicle",
      "misc"
    ]
  },
  {
    "name": "info-circle",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "notifications"
    ],
    "unicode": "e125",
    "id": 1212,
    "tags": [
      "info",
      "circle",
      "notifications",
      "information",
      "help",
      "about"
    ]
  },
  {
    "name": "inherited",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "files-and-folders"
    ],
    "unicode": "e126",
    "id": 1213,
    "tags": [
      "inherited",
      "files-and-folders"
    ]
  },
  {
    "name": "inputbox",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e127",
    "id": 1214,
    "tags": [
      "inputbox",
      "editing"
    ]
  },
  {
    "name": "insert-bottom",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "text-formatting"
    ],
    "unicode": "e128",
    "id": 1215,
    "tags": [
      "insert",
      "bottom",
      "text-formatting"
    ]
  },
  {
    "name": "insert-middle",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "text-formatting"
    ],
    "unicode": "e129",
    "id": 1216,
    "tags": [
      "insert",
      "middle",
      "text-formatting"
    ]
  },
  {
    "name": "insert-top",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "text-formatting"
    ],
    "unicode": "e12a",
    "id": 1217,
    "tags": [
      "insert",
      "top",
      "text-formatting"
    ]
  },
  {
    "name": "instagram",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "social"
    ],
    "unicode": "e12b",
    "id": 1218,
    "tags": [
      "instagram",
      "social"
    ]
  },
  {
    "name": "invert-colors",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "images"
    ],
    "unicode": "e12c",
    "id": 1219,
    "tags": [
      "invert",
      "colors",
      "images"
    ]
  },
  {
    "name": "italic",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "text-formatting"
    ],
    "unicode": "e12d",
    "id": 1220,
    "tags": [
      "italic",
      "text-formatting",
      "emphasis",
      "text"
    ]
  },
  {
    "name": "filter-add-expression",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e12e",
    "id": 157,
    "tags": [
      "filter",
      "add",
      "expression",
      "actions",
      "funnel",
      "sieve",
      "plus",
      "create",
      "new"
    ]
  },
  {
    "name": "filter-add-group",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e12f",
    "id": 158,
    "tags": [
      "filter",
      "add",
      "group",
      "actions",
      "funnel",
      "sieve",
      "plus",
      "create",
      "new",
      "combine",
      "merge",
      "collect"
    ]
  },
  {
    "name": "js",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "files-and-folders"
    ],
    "unicode": "e130",
    "id": 1221,
    "tags": [
      "js",
      "files-and-folders"
    ]
  },
  {
    "name": "launch",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e131",
    "id": 1222,
    "tags": [
      "launch",
      "actions"
    ]
  },
  {
    "name": "less-or-equal",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e132",
    "id": 1223,
    "tags": [
      "less",
      "or",
      "equal",
      "actions",
      "fewer",
      "smaller",
      "below",
      "same",
      "match",
      "balance"
    ]
  },
  {
    "name": "level-down",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "navigation",
      "arrows"
    ],
    "unicode": "e133",
    "id": 1224,
    "tags": [
      "level",
      "down",
      "navigation",
      "arrows"
    ]
  },
  {
    "name": "level-to-top",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "navigation",
      "arrows"
    ],
    "unicode": "e134",
    "id": 1225,
    "tags": [
      "level",
      "to",
      "top",
      "navigation",
      "arrows"
    ]
  },
  {
    "name": "level-up",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "navigation",
      "arrows"
    ],
    "unicode": "e135",
    "id": 1226,
    "tags": [
      "level",
      "up",
      "navigation",
      "arrows"
    ]
  },
  {
    "name": "line-shape",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e136",
    "id": 1227,
    "tags": [
      "line",
      "shape",
      "editing",
      "chart",
      "graph",
      "trend",
      "form",
      "polygon",
      "geometry"
    ]
  },
  {
    "name": "link-vertical",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e137",
    "id": 1228,
    "tags": [
      "link",
      "vertical",
      "actions",
      "chain",
      "url",
      "hyperlink"
    ]
  },
  {
    "name": "link",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e138",
    "id": 1229,
    "tags": [
      "anchor",
      "hyperlink",
      "hypertext",
      "chains",
      "chained"
    ]
  },
  {
    "name": "linkedin",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "social"
    ],
    "unicode": "e139",
    "id": 1230,
    "tags": [
      "linkedin",
      "social"
    ]
  },
  {
    "name": "list-ordered",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "text-formatting"
    ],
    "unicode": "e13a",
    "id": 1231,
    "tags": [
      "list",
      "ordered",
      "text-formatting",
      "bullet",
      "items",
      "menu"
    ]
  },
  {
    "name": "list-unordered-square",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "css",
      "list"
    ],
    "unicode": "e13b",
    "id": 1232,
    "tags": [
      "list",
      "unordered",
      "square",
      "css",
      "bullet",
      "items",
      "menu"
    ]
  },
  {
    "name": "list-unordered",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "text-formatting"
    ],
    "unicode": "e13c",
    "id": 1233,
    "tags": [
      "list",
      "unordered",
      "text-formatting",
      "bullet",
      "items",
      "menu"
    ]
  },
  {
    "name": "locations",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "maps"
    ],
    "unicode": "e13d",
    "id": 1234,
    "tags": [
      "locations",
      "maps"
    ]
  },
  {
    "name": "lock",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e13e",
    "id": 1235,
    "tags": [
      "padlock",
      "security",
      "secured",
      "authentication",
      "authenticated",
      "login",
      "locked",
      "encrypted",
      "encryption",
      "privacy",
      "private"
    ]
  },
  {
    "name": "login",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e13f",
    "id": 1236,
    "tags": [
      "login",
      "actions"
    ]
  },
  {
    "name": "logout",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e140",
    "id": 1237,
    "tags": [
      "logout",
      "actions"
    ]
  },
  {
    "name": "make-horizontal-spacing-equal",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e141",
    "id": 1238,
    "tags": [
      "make",
      "horizontal",
      "spacing",
      "equal",
      "editing",
      "same",
      "match",
      "balance"
    ]
  },
  {
    "name": "make-vertical-spacing-equal",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e142",
    "id": 1239,
    "tags": [
      "make",
      "vertical",
      "spacing",
      "equal",
      "editing",
      "same",
      "match",
      "balance"
    ]
  },
  {
    "name": "map-marker-target",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "maps"
    ],
    "unicode": "e143",
    "id": 1240,
    "tags": [
      "map",
      "marker",
      "target",
      "maps",
      "location",
      "navigation",
      "place"
    ]
  },
  {
    "name": "map-marker",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "maps"
    ],
    "unicode": "e144",
    "id": 1241,
    "tags": [
      "map",
      "marker",
      "maps",
      "location",
      "navigation",
      "place"
    ]
  },
  {
    "name": "max-height",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "css",
      "layout"
    ],
    "unicode": "e145",
    "id": 1242,
    "tags": [
      "max",
      "height",
      "css",
      "layout"
    ]
  },
  {
    "name": "max-width",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "css",
      "layout"
    ],
    "unicode": "e146",
    "id": 1243,
    "tags": [
      "max",
      "width",
      "css",
      "layout"
    ]
  },
  {
    "name": "kpi-status-deny",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e147",
    "id": 182,
    "tags": [
      "kpi",
      "status",
      "deny",
      "actions"
    ]
  },
  {
    "name": "kpi-status-hold",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e148",
    "id": 183,
    "tags": [
      "kpi",
      "status",
      "hold",
      "actions"
    ]
  },
  {
    "name": "kpi-status-open",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e149",
    "id": 184,
    "tags": [
      "kpi",
      "status",
      "open",
      "actions"
    ]
  },
  {
    "name": "media-manager",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "media"
    ],
    "unicode": "e14a",
    "id": 1244,
    "tags": [
      "media",
      "manager"
    ]
  },
  {
    "name": "menu-filter",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e14b",
    "id": 1245,
    "tags": [
      "menu",
      "filter",
      "actions",
      "hamburger",
      "navigation",
      "sidebar",
      "funnel",
      "sieve"
    ]
  },
  {
    "name": "menu-sort-asc",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e14c",
    "id": 1246,
    "tags": [
      "menu",
      "sort",
      "asc",
      "actions",
      "hamburger",
      "navigation",
      "sidebar",
      "order",
      "arrange"
    ]
  },
  {
    "name": "menu-sort-desc",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e14d",
    "id": 1247,
    "tags": [
      "menu",
      "sort",
      "desc",
      "actions",
      "hamburger",
      "navigation",
      "sidebar",
      "order",
      "arrange"
    ]
  },
  {
    "name": "menu",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "navigation"
    ],
    "unicode": "e14e",
    "id": 1248,
    "tags": [
      "menu",
      "navigation",
      "hamburger",
      "sidebar"
    ]
  },
  {
    "name": "min-height",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "css",
      "layout"
    ],
    "unicode": "e14f",
    "id": 1249,
    "tags": [
      "min",
      "height",
      "css",
      "layout"
    ]
  },
  {
    "name": "min-width",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "css",
      "layout"
    ],
    "unicode": "e150",
    "id": 1250,
    "tags": [
      "min",
      "width",
      "css",
      "layout"
    ]
  },
  {
    "name": "minus-circle",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e151",
    "id": 1251,
    "tags": [
      "-",
      "subtraction",
      "difference",
      "mathematics",
      "arithmetic",
      "calculator",
      "round"
    ]
  },
  {
    "name": "minus",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e152",
    "id": 1252,
    "tags": [
      "-",
      "subtraction",
      "difference",
      "mathematics",
      "arithmetic",
      "calculator",
      "line",
      "horizontal",
      "divider"
    ]
  },
  {
    "name": "mirror",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "images"
    ],
    "unicode": "e153",
    "id": 1253,
    "tags": [
      "mirror",
      "images"
    ]
  },
  {
    "name": "money-exchange",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "misc"
    ],
    "unicode": "e154",
    "id": 1254,
    "tags": [
      "money",
      "exchange",
      "misc"
    ]
  },
  {
    "name": "more-horizontal",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e155",
    "id": 1255,
    "tags": [
      "more",
      "horizontal",
      "actions"
    ]
  },
  {
    "name": "more-vertical",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e156",
    "id": 1256,
    "tags": [
      "more",
      "vertical",
      "actions"
    ]
  },
  {
    "name": "music-notes",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "media"
    ],
    "unicode": "e157",
    "id": 1257,
    "tags": [
      "songs",
      "audio",
      "playlist",
      "albums"
    ]
  },
  {
    "name": "myspace",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "social"
    ],
    "unicode": "e158",
    "id": 1258,
    "tags": [
      "myspace",
      "social"
    ]
  },
  {
    "name": "not-equal",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e159",
    "id": 1259,
    "tags": [
      "not",
      "equal",
      "actions",
      "same",
      "match",
      "balance"
    ]
  },
  {
    "name": "optimization",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e15a",
    "id": 1260,
    "tags": [
      "optimization",
      "actions"
    ]
  },
  {
    "name": "outdent",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "text-formatting"
    ],
    "unicode": "e15b",
    "id": 1261,
    "tags": [
      "outdent",
      "text-formatting"
    ]
  },
  {
    "name": "page-footer-section",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "files-and-folders"
    ],
    "unicode": "e15c",
    "id": 1262,
    "tags": [
      "page",
      "footer",
      "section",
      "files-and-folders"
    ]
  },
  {
    "name": "page-header-section",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "files-and-folders"
    ],
    "unicode": "e15d",
    "id": 1263,
    "tags": [
      "page",
      "header",
      "section",
      "files-and-folders"
    ]
  },
  {
    "name": "palette",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "images"
    ],
    "unicode": "e15e",
    "id": 1264,
    "tags": [
      "paint",
      "colors",
      "color picker",
      "arts"
    ]
  },
  {
    "name": "paper-plane",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e15f",
    "id": 1265,
    "tags": [
      "mail",
      "email",
      "send",
      "sent",
      "messages",
      "messaging",
      "toys",
      "games"
    ]
  },
  {
    "name": "paperclip",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e160",
    "id": 1266,
    "tags": [
      "attachments",
      "mail",
      "email",
      "office"
    ]
  },
  {
    "name": "paragraph-add",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e161",
    "id": 1267,
    "tags": [
      "paragraph",
      "add",
      "editing",
      "text",
      "block",
      "content",
      "plus",
      "create",
      "new"
    ]
  },
  {
    "name": "paragraph-height",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "text-formatting"
    ],
    "unicode": "e162",
    "id": 1268,
    "tags": [
      "paragraph",
      "height",
      "text-formatting",
      "text",
      "block",
      "content"
    ]
  },
  {
    "name": "paragraph-mark",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e163",
    "id": 1269,
    "tags": [
      "paragraph",
      "mark",
      "editing",
      "text",
      "block",
      "content"
    ]
  },
  {
    "name": "parameter-boolean",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "files-and-folders"
    ],
    "unicode": "e164",
    "id": 1270,
    "tags": [
      "parameter",
      "boolean",
      "files-and-folders"
    ]
  },
  {
    "name": "parameter-date-time",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "files-and-folders"
    ],
    "unicode": "e165",
    "id": 1271,
    "tags": [
      "parameter",
      "date",
      "time",
      "files-and-folders"
    ]
  },
  {
    "name": "parameters",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "files-and-folders"
    ],
    "unicode": "e166",
    "id": 1272,
    "tags": [
      "parameters",
      "files-and-folders"
    ]
  },
  {
    "name": "password-box",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e167",
    "id": 1273,
    "tags": [
      "password",
      "box",
      "editing",
      "container",
      "package",
      "cube"
    ]
  },
  {
    "name": "password",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e168",
    "id": 1274,
    "tags": [
      "security",
      "secured",
      "authentication",
      "authenticated",
      "login",
      "locked",
      "encrypted",
      "encryption"
    ]
  },
  {
    "name": "paste-sparkle",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e169",
    "id": 1275,
    "tags": [
      "paste",
      "sparkle",
      "editing",
      "clipboard"
    ]
  },
  {
    "name": "pause",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "media"
    ],
    "unicode": "e16a",
    "id": 1276,
    "tags": [
      "music",
      "audio",
      "resume",
      "start",
      "stop"
    ]
  },
  {
    "name": "pencil",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e16b",
    "id": 1277,
    "tags": [
      "write",
      "writing",
      "editing",
      "sign",
      "signature"
    ]
  },
  {
    "name": "percent",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e16c",
    "id": 1278,
    "tags": [
      "%",
      "percentage",
      "percentile",
      "ratio",
      "delta",
      "mathematics",
      "arithmetic",
      "calculator"
    ]
  },
  {
    "name": "perimeter",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e16d",
    "id": 1279,
    "tags": [
      "perimeter",
      "editing"
    ]
  },
  {
    "name": "photos",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "images"
    ],
    "unicode": "e16e",
    "id": 1280,
    "tags": [
      "photos",
      "images"
    ]
  },
  {
    "name": "pin",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "maps"
    ],
    "unicode": "e16f",
    "id": 1281,
    "tags": [
      "pin",
      "maps",
      "marker",
      "location",
      "place"
    ]
  },
  {
    "name": "pinterest",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "social"
    ],
    "unicode": "e170",
    "id": 1282,
    "tags": [
      "pinterest",
      "social"
    ]
  },
  {
    "name": "plan",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "files-and-folders"
    ],
    "unicode": "e171",
    "id": 1283,
    "tags": [
      "plan",
      "files-and-folders"
    ]
  },
  {
    "name": "play",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "media"
    ],
    "unicode": "e172",
    "id": 1284,
    "tags": [
      "music",
      "audio",
      "resume",
      "start"
    ]
  },
  {
    "name": "playlist",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "media"
    ],
    "unicode": "e173",
    "id": 1285,
    "tags": [
      "music",
      "audio",
      "queue"
    ]
  },
  {
    "name": "plus-circle",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e174",
    "id": 1286,
    "tags": [
      "addition",
      "sum",
      "mathematics",
      "arithmetic",
      "calculator",
      "round",
      "+"
    ]
  },
  {
    "name": "plus",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e175",
    "id": 1287,
    "tags": [
      "addition",
      "sum",
      "mathematics",
      "arithmetic",
      "calculator",
      "+"
    ]
  },
  {
    "name": "pointer",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e176",
    "id": 1288,
    "tags": [
      "pointer",
      "actions"
    ]
  },
  {
    "name": "print",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e177",
    "id": 1289,
    "tags": [
      "print",
      "actions",
      "printer",
      "output"
    ]
  },
  {
    "name": "puzzle-piece",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e178",
    "id": 1290,
    "tags": [
      "board game",
      "element",
      "component",
      "extension",
      "plugin"
    ]
  },
  {
    "name": "qr-code-scanner",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e179",
    "id": 1291,
    "tags": [
      "qr",
      "code",
      "scanner",
      "actions",
      "programming",
      "developer",
      "html"
    ]
  },
  {
    "name": "qr-code",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e17a",
    "id": 1292,
    "tags": [
      "upc",
      "barcode",
      "products",
      "shopping",
      "scanner"
    ]
  },
  {
    "name": "question-circle",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "notifications"
    ],
    "unicode": "e17b",
    "id": 1293,
    "tags": [
      "question",
      "circle",
      "notifications"
    ]
  },
  {
    "name": "radiobutton-checked",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "toggle"
    ],
    "unicode": "e17c",
    "id": 1294,
    "tags": [
      "radiobutton",
      "checked",
      "toggle"
    ]
  },
  {
    "name": "radiobutton",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "toggle"
    ],
    "unicode": "e17d",
    "id": 1295,
    "tags": [
      "radiobutton",
      "toggle"
    ]
  },
  {
    "name": "rectangle-shape",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e17e",
    "id": 1296,
    "tags": [
      "rectangle",
      "shape",
      "editing",
      "form",
      "polygon",
      "geometry"
    ]
  },
  {
    "name": "reddit",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "social"
    ],
    "unicode": "e17f",
    "id": 1297,
    "tags": [
      "reddit",
      "social"
    ]
  },
  {
    "name": "redo",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e180",
    "id": 1298,
    "tags": [
      "redo",
      "actions",
      "forward",
      "repeat"
    ]
  },
  {
    "name": "regular-expression",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "text-formatting"
    ],
    "unicode": "e181",
    "id": 1299,
    "tags": [
      "regular",
      "expression",
      "text-formatting"
    ]
  },
  {
    "name": "remove-horizontal-spacing",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e182",
    "id": 1300,
    "tags": [
      "remove",
      "horizontal",
      "spacing",
      "editing",
      "delete",
      "minus",
      "subtract"
    ]
  },
  {
    "name": "remove-vertical-spacing",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e183",
    "id": 1301,
    "tags": [
      "remove",
      "vertical",
      "spacing",
      "editing",
      "delete",
      "minus",
      "subtract"
    ]
  },
  {
    "name": "address-book-tabs",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "social"
    ],
    "unicode": "e184",
    "id": 844,
    "tags": [
      "contacts",
      "directory",
      "roledex"
    ]
  },
  {
    "name": "address-book",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "social"
    ],
    "unicode": "e185",
    "id": 845,
    "tags": [
      "contacts",
      "directory",
      "roledex"
    ]
  },
  {
    "name": "arrows-clockwise",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "navigation"
    ],
    "unicode": "e186",
    "id": 846,
    "tags": [
      "directional",
      "pointer",
      "pointing",
      "arrowhead",
      "redo",
      "refreshing",
      "sync",
      "synchronize",
      "rotate",
      "spin",
      "flip"
    ]
  },
  {
    "name": "arrows-counter-clockwise",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "navigation"
    ],
    "unicode": "e187",
    "id": 847,
    "tags": [
      "directional",
      "pointer",
      "pointing",
      "arrowhead",
      "undo",
      "refreshing",
      "rotate",
      "spin",
      "flip"
    ]
  },
  {
    "name": "arrows-out-line-horizontal",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "navigation"
    ],
    "unicode": "e188",
    "id": 848,
    "tags": [
      "directional",
      "pointer",
      "pointing",
      "arrowhead",
      "open",
      "split"
    ]
  },
  {
    "name": "arrows-out-line-vertical",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "navigation"
    ],
    "unicode": "e189",
    "id": 849,
    "tags": [
      "directional",
      "pointer",
      "pointing",
      "arrowhead",
      "open",
      "split"
    ]
  },
  {
    "name": "arrows-out-simple",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "navigation"
    ],
    "unicode": "e18a",
    "id": 850,
    "tags": [
      "directional",
      "pointer",
      "pointing",
      "arrowhead",
      "expand",
      "fullscreen",
      "resize"
    ]
  },
  {
    "name": "arrows-rotate",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "navigation"
    ],
    "unicode": "e18b",
    "id": 851,
    "tags": [
      "arrows",
      "rotate",
      "navigation",
      "turn",
      "spin",
      "orientation"
    ]
  },
  {
    "name": "arrows-split",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "navigation"
    ],
    "unicode": "e18c",
    "id": 852,
    "tags": [
      "arrowheads",
      "fork"
    ]
  },
  {
    "name": "award-number",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "misc"
    ],
    "unicode": "e18d",
    "id": 853,
    "tags": [
      "award",
      "number",
      "misc",
      "digit",
      "count",
      "numeric"
    ]
  },
  {
    "name": "award-trophy",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "misc"
    ],
    "unicode": "e18e",
    "id": 854,
    "tags": [
      "award",
      "trophy",
      "misc",
      "prize",
      "winner"
    ]
  },
  {
    "name": "bank",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "misc"
    ],
    "unicode": "e18f",
    "id": 855,
    "tags": [
      "banking",
      "checking",
      "money",
      "savings",
      "deposit",
      "withdraw",
      "places",
      "locations"
    ]
  },
  {
    "name": "bathtub",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "misc"
    ],
    "unicode": "e190",
    "id": 856,
    "tags": [
      "bath",
      "shower",
      "bathroom",
      "faucet"
    ]
  },
  {
    "name": "bed",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "misc"
    ],
    "unicode": "e191",
    "id": 857,
    "tags": [
      "hotels",
      "accommodations",
      "sleeping",
      "places",
      "locations",
      "medical",
      "hospital"
    ]
  },
  {
    "name": "book-open-text",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e192",
    "id": 858,
    "tags": [
      "reading",
      "reader",
      "novel",
      "story",
      "library"
    ]
  },
  {
    "name": "book-open-user",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e193",
    "id": 859,
    "tags": [
      "reading",
      "reader",
      "easy read",
      "library",
      "places",
      "locations"
    ]
  },
  {
    "name": "book-open",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e194",
    "id": 860,
    "tags": [
      "reading",
      "reader",
      "novel",
      "story",
      "library"
    ]
  },
  {
    "name": "books",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e195",
    "id": 861,
    "tags": [
      "reading",
      "reader",
      "bookshelf",
      "library",
      "places",
      "locations"
    ]
  },
  {
    "name": "box-arrow-down",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e196",
    "id": 862,
    "tags": [
      "saved",
      "saving",
      "archived",
      "archiving",
      "archival",
      "downloaded",
      "downloading"
    ]
  },
  {
    "name": "brain",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "misc"
    ],
    "unicode": "e197",
    "id": 863,
    "tags": [
      "mind",
      "mental"
    ]
  },
  {
    "name": "bug",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "misc"
    ],
    "unicode": "e198",
    "id": 864,
    "tags": [
      "debug",
      "errors",
      "insect",
      "ladybug"
    ]
  },
  {
    "name": "buildings",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "misc"
    ],
    "unicode": "e199",
    "id": 865,
    "tags": [
      "places",
      "locations",
      "company",
      "business"
    ]
  },
  {
    "name": "cell-tower",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "misc"
    ],
    "unicode": "e19a",
    "id": 866,
    "tags": [
      "wireless",
      "cellular",
      "broadcast",
      "phone",
      "mobile",
      "network",
      "connection",
      "connectivity"
    ]
  },
  {
    "name": "chart-line-down",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "charts"
    ],
    "unicode": "e19b",
    "id": 867,
    "tags": [
      "graphs",
      "graphing",
      "charts",
      "statistics",
      "analyze",
      "analysis",
      "stocks"
    ]
  },
  {
    "name": "circuitry",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "misc"
    ],
    "unicode": "e19c",
    "id": 868,
    "tags": [
      "processor",
      "microchip",
      "computer",
      "circuit",
      "electronics",
      "motherboard"
    ]
  },
  {
    "name": "clean",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e19d",
    "id": 869,
    "tags": [
      "clean",
      "actions"
    ]
  },
  {
    "name": "cloud-arrow-up",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "files-and-folders"
    ],
    "unicode": "e19e",
    "id": 870,
    "tags": [
      "serverless",
      "backup",
      "storage",
      "upload"
    ]
  },
  {
    "name": "cloud-lightning",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "files-and-folders"
    ],
    "unicode": "e19f",
    "id": 871,
    "tags": [
      "meteorology",
      "cloudy",
      "overcast",
      "stormy",
      "thunderstorm"
    ]
  },
  {
    "name": "computer-tower",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "misc"
    ],
    "unicode": "e1a0",
    "id": 872,
    "tags": [
      "desktop",
      "pc",
      "imac"
    ]
  },
  {
    "name": "corners-out",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "navigation"
    ],
    "unicode": "e1a1",
    "id": 873,
    "tags": [
      "expand",
      "fullscreen",
      "maximized"
    ]
  },
  {
    "name": "cpu",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "misc"
    ],
    "unicode": "e1a2",
    "id": 874,
    "tags": [
      "processor",
      "microchip",
      "computer",
      "circuit"
    ]
  },
  {
    "name": "crosshair-simple",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "misc"
    ],
    "unicode": "e1a3",
    "id": 875,
    "tags": [
      "geolocation",
      "gps",
      "aiming",
      "targeting"
    ]
  },
  {
    "name": "cube-focus",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e1a4",
    "id": 876,
    "tags": [
      "augmented reality",
      "ar",
      "virual reality",
      "vr",
      "3d",
      "scan"
    ]
  },
  {
    "name": "cube-transparent",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e1a5",
    "id": 877,
    "tags": [
      "square",
      "box",
      "3d",
      "volume",
      "blocks",
      "necker"
    ]
  },
  {
    "name": "dashboard",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "misc"
    ],
    "unicode": "e1a6",
    "id": 878,
    "tags": [
      "dashboard",
      "misc"
    ]
  },
  {
    "name": "desktop-tower",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "social"
    ],
    "unicode": "e1a7",
    "id": 879,
    "tags": [
      "computer",
      "pc",
      "imac"
    ]
  },
  {
    "name": "desktop",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "social"
    ],
    "unicode": "e1a8",
    "id": 880,
    "tags": [
      "computer",
      "pc",
      "imac",
      "tower"
    ]
  },
  {
    "name": "devices",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "social"
    ],
    "unicode": "e1a9",
    "id": 881,
    "tags": [
      "responsive",
      "cellphone",
      "cellular",
      "tablet",
      "desktop"
    ]
  },
  {
    "name": "disc",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "misc"
    ],
    "unicode": "e1aa",
    "id": 882,
    "tags": [
      "cd-rom",
      "compact disk",
      "album",
      "record"
    ]
  },
  {
    "name": "discount",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "misc"
    ],
    "unicode": "e1ab",
    "id": 883,
    "tags": [
      "discount",
      "misc"
    ]
  },
  {
    "name": "doctor",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "misc"
    ],
    "unicode": "e1ac",
    "id": 884,
    "tags": [
      "doctor",
      "misc"
    ]
  },
  {
    "name": "education",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "misc"
    ],
    "unicode": "e1ad",
    "id": 885,
    "tags": [
      "education",
      "misc"
    ]
  },
  {
    "name": "eraser",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e1ae",
    "id": 886,
    "tags": [
      "write",
      "writing",
      "editing",
      "undo",
      "deleted"
    ]
  },
  {
    "name": "faders-horizontal",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e1af",
    "id": 887,
    "tags": [
      "music",
      "audio",
      "sliders",
      "filters",
      "equalizer",
      "volume",
      "settings",
      "preferences"
    ]
  },
  {
    "name": "faders",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e1b0",
    "id": 888,
    "tags": [
      "music",
      "audio",
      "sliders",
      "filters",
      "equalizer",
      "volume",
      "settings",
      "preferences"
    ]
  },
  {
    "name": "file-arrow-up",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "files-and-folders"
    ],
    "unicode": "e1b1",
    "id": 889,
    "tags": [
      "documents",
      "files",
      "save",
      "write",
      "upload",
      "directional",
      "pointer",
      "pointing",
      "arrowhead"
    ]
  },
  {
    "name": "file-clock",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "files-and-folders"
    ],
    "unicode": "e1b2",
    "id": 890,
    "tags": [
      "file",
      "clock",
      "files-and-folders",
      "document",
      "page",
      "paper",
      "time",
      "timer",
      "schedule"
    ]
  },
  {
    "name": "files",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e1b3",
    "id": 891,
    "tags": [
      "documents",
      "open",
      "library"
    ]
  },
  {
    "name": "filter-sort-asc",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e1b4",
    "id": 892,
    "tags": [
      "filter",
      "sort",
      "asc",
      "actions",
      "funnel",
      "sieve",
      "order",
      "arrange"
    ]
  },
  {
    "name": "filter-sort-desc",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e1b5",
    "id": 893,
    "tags": [
      "filter",
      "sort",
      "desc",
      "actions",
      "funnel",
      "sieve",
      "order",
      "arrange"
    ]
  },
  {
    "name": "flashlight",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "misc"
    ],
    "unicode": "e1b6",
    "id": 894,
    "tags": [
      "torch",
      "find",
      "search",
      "locate"
    ]
  },
  {
    "name": "food",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "misc"
    ],
    "unicode": "e1b7",
    "id": 895,
    "tags": [
      "food",
      "misc"
    ]
  },
  {
    "name": "gear-fine",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e1b8",
    "id": 896,
    "tags": [
      "setup",
      "preferences",
      "cogs",
      "gears",
      "machinery",
      "mechanical"
    ]
  },
  {
    "name": "git-diff",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "misc"
    ],
    "unicode": "e1b9",
    "id": 897,
    "tags": [
      "github",
      "vcs",
      "source control",
      "version control",
      "versioning",
      "difference",
      "compare"
    ]
  },
  {
    "name": "git-fork",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "misc"
    ],
    "unicode": "e1ba",
    "id": 898,
    "tags": [
      "github",
      "vcs",
      "source control",
      "version control",
      "versioning",
      "split"
    ]
  },
  {
    "name": "git-merge",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "misc"
    ],
    "unicode": "e1bb",
    "id": 899,
    "tags": [
      "github",
      "vcs",
      "source control",
      "version control",
      "versioning",
      "split"
    ]
  },
  {
    "name": "hard-drive",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "misc"
    ],
    "unicode": "e1bc",
    "id": 900,
    "tags": [
      "saved",
      "saving",
      "archived",
      "archiving",
      "archival",
      "hard disk",
      "storage",
      "hdd",
      "servers",
      "databases"
    ]
  },
  {
    "name": "hard-drives",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "misc"
    ],
    "unicode": "e1bd",
    "id": 901,
    "tags": [
      "saved",
      "saving",
      "archived",
      "archiving",
      "archival",
      "hard disk",
      "storage",
      "hdd",
      "servers",
      "databases"
    ]
  },
  {
    "name": "head-circuit",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "misc"
    ],
    "unicode": "e1be",
    "id": 902,
    "tags": [
      "automaton",
      "artificial intelligence",
      "ai"
    ]
  },
  {
    "name": "lab-technician",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "misc"
    ],
    "unicode": "e1bf",
    "id": 903,
    "tags": [
      "lab",
      "technician",
      "misc"
    ]
  },
  {
    "name": "laptop",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "social"
    ],
    "unicode": "e1c0",
    "id": 904,
    "tags": [
      "computer",
      "notebook",
      "pc",
      "macbook"
    ]
  },
  {
    "name": "lightbulb",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "misc"
    ],
    "unicode": "e1c1",
    "id": 905,
    "tags": [
      "flashlight",
      "bulbs",
      "lighting",
      "led",
      "energy",
      "idea"
    ]
  },
  {
    "name": "lightning",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "misc"
    ],
    "unicode": "e1c2",
    "id": 906,
    "tags": [
      "meteorology",
      "stormy",
      "thunderstorm",
      "thunderbolt",
      "charged",
      "charger",
      "charging",
      "power",
      "electricity",
      "flash"
    ]
  },
  {
    "name": "line-vertical",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "layout"
    ],
    "unicode": "e1c3",
    "id": 907,
    "tags": [
      "bar",
      "pipe",
      "|",
      "divider. symbol"
    ]
  },
  {
    "name": "list-bullets",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "text-formatting"
    ],
    "unicode": "e1c4",
    "id": 908,
    "tags": [
      "ul",
      "unordered list",
      "bulleted list",
      "checklist"
    ]
  },
  {
    "name": "list-numbers",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "text-formatting"
    ],
    "unicode": "e1c5",
    "id": 909,
    "tags": [
      "ol",
      "ordered list",
      "numbered list",
      "checklist"
    ]
  },
  {
    "name": "luggage",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "misc"
    ],
    "unicode": "e1c6",
    "id": 910,
    "tags": [
      "luggage",
      "misc"
    ]
  },
  {
    "name": "map-pin-area",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "maps"
    ],
    "unicode": "e1c7",
    "id": 911,
    "tags": [
      "maps",
      "places",
      "markers",
      "pins",
      "locations",
      "poi",
      "point of interest"
    ]
  },
  {
    "name": "map-pin-simple-line",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "maps"
    ],
    "unicode": "e1c8",
    "id": 912,
    "tags": [
      "maps",
      "places",
      "markers",
      "pins",
      "locations",
      "poi",
      "point of interest"
    ]
  },
  {
    "name": "map-pin",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "maps"
    ],
    "unicode": "e1c9",
    "id": 913,
    "tags": [
      "maps",
      "places",
      "markers",
      "pins",
      "locations",
      "poi",
      "point of interest"
    ]
  },
  {
    "name": "memory",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "misc"
    ],
    "unicode": "e1ca",
    "id": 914,
    "tags": [
      "ram",
      "microchip",
      "computer",
      "circuit",
      "electronics"
    ]
  },
  {
    "name": "microphone",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "media"
    ],
    "unicode": "e1cb",
    "id": 915,
    "tags": [
      "audio",
      "recording",
      "music",
      "sound",
      "podcast",
      "studio"
    ]
  },
  {
    "name": "mobile-ringing",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "social"
    ],
    "unicode": "e1cc",
    "id": 916,
    "tags": [
      "mobile",
      "ringing",
      "social"
    ]
  },
  {
    "name": "mobile",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "social"
    ],
    "unicode": "e1cd",
    "id": 917,
    "tags": [
      "mobile",
      "social"
    ]
  },
  {
    "name": "monitor-arrow-up",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "social"
    ],
    "unicode": "e1ce",
    "id": 918,
    "tags": [
      "screen",
      "screencast",
      "screenshare",
      "upload",
      "video",
      "movie"
    ]
  },
  {
    "name": "monitor-play",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "social"
    ],
    "unicode": "e1cf",
    "id": 919,
    "tags": [
      "screen",
      "television",
      "tv",
      "displays",
      "screencast",
      "video",
      "movie"
    ]
  },
  {
    "name": "monitor",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "social"
    ],
    "unicode": "e1d0",
    "id": 920,
    "tags": [
      "screen",
      "television",
      "tv",
      "displays"
    ]
  },
  {
    "name": "mouse-scroll",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "misc"
    ],
    "unicode": "e1d1",
    "id": 921,
    "tags": [
      "clicks",
      "input"
    ]
  },
  {
    "name": "non-stop",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "misc"
    ],
    "unicode": "e1d2",
    "id": 922,
    "tags": [
      "non",
      "stop",
      "misc",
      "end",
      "halt",
      "media"
    ]
  },
  {
    "name": "nurse",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "misc"
    ],
    "unicode": "e1d3",
    "id": 923,
    "tags": [
      "nurse",
      "misc"
    ]
  },
  {
    "name": "nut",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "misc"
    ],
    "unicode": "e1d4",
    "id": 924,
    "tags": [
      "bolts",
      "screws",
      "machinery",
      "tools",
      "hexagon"
    ]
  },
  {
    "name": "package",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "misc"
    ],
    "unicode": "e1d5",
    "id": 925,
    "tags": [
      "packages",
      "boxes",
      "delivery",
      "mail",
      "postal service",
      "bundles",
      "library",
      "libraries",
      "shipping"
    ]
  },
  {
    "name": "path",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "misc"
    ],
    "unicode": "e1d6",
    "id": 926,
    "tags": [
      "transit",
      "travel",
      "trail",
      "gps",
      "navigation",
      "route",
      "destination",
      "vector"
    ]
  },
  {
    "name": "patient",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "misc"
    ],
    "unicode": "e1d7",
    "id": 927,
    "tags": [
      "patient",
      "misc"
    ]
  },
  {
    "name": "piggy-bank",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "misc"
    ],
    "unicode": "e1d8",
    "id": 928,
    "tags": [
      "savings",
      "deposit",
      "money",
      "coins"
    ]
  },
  {
    "name": "pills",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "misc"
    ],
    "unicode": "e1d9",
    "id": 929,
    "tags": [
      "pills",
      "misc"
    ]
  },
  {
    "name": "pin-bottom",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e1da",
    "id": 930,
    "tags": [
      "pin",
      "bottom",
      "actions",
      "marker",
      "location",
      "place"
    ]
  },
  {
    "name": "pin-top",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e1db",
    "id": 931,
    "tags": [
      "pin",
      "top",
      "actions",
      "marker",
      "location",
      "place"
    ]
  },
  {
    "name": "plane",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "misc"
    ],
    "unicode": "e1dc",
    "id": 932,
    "tags": [
      "plane",
      "misc"
    ]
  },
  {
    "name": "recycle",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "misc"
    ],
    "unicode": "e1dd",
    "id": 933,
    "tags": [
      "recycling",
      "trash",
      "environmental",
      "green"
    ]
  },
  {
    "name": "repeat-once",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e1de",
    "id": 934,
    "tags": [
      "music",
      "audio",
      "recycle"
    ]
  },
  {
    "name": "repeat",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e1df",
    "id": 935,
    "tags": [
      "music",
      "audio",
      "recycle"
    ]
  },
  {
    "name": "robot",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "misc"
    ],
    "unicode": "e1e0",
    "id": 936,
    "tags": [
      "automaton",
      "artificial intelligence",
      "ai"
    ]
  },
  {
    "name": "rocket-launch",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "misc"
    ],
    "unicode": "e1e1",
    "id": 937,
    "tags": [
      "spaceship",
      "flying",
      "blastoff",
      "deployment",
      "rocketship"
    ]
  },
  {
    "name": "rocket",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "misc"
    ],
    "unicode": "e1e2",
    "id": 938,
    "tags": [
      "spaceship",
      "launch",
      "deployment",
      "rocketship"
    ]
  },
  {
    "name": "ruler-triangle",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e1e3",
    "id": 939,
    "tags": [
      "ruler",
      "triangle",
      "editing",
      "measure",
      "guide",
      "size"
    ]
  },
  {
    "name": "ruler",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e1e4",
    "id": 940,
    "tags": [
      "measure",
      "scale",
      "distance"
    ]
  },
  {
    "name": "scroll",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "misc"
    ],
    "unicode": "e1e5",
    "id": 941,
    "tags": [
      "parchment",
      "paper",
      "script",
      "spell",
      "fantasy"
    ]
  },
  {
    "name": "security-check",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "misc"
    ],
    "unicode": "e1e6",
    "id": 942,
    "tags": [
      "security",
      "check",
      "misc",
      "tick",
      "done",
      "confirm"
    ]
  },
  {
    "name": "security-lock",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "misc"
    ],
    "unicode": "e1e7",
    "id": 943,
    "tags": [
      "security",
      "lock",
      "misc",
      "secure",
      "private",
      "password"
    ]
  },
  {
    "name": "shopping-bag-open",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e1e8",
    "id": 944,
    "tags": [
      "ecommerce",
      "market",
      "basket",
      "cart",
      "buying",
      "checkout",
      "places",
      "locations"
    ]
  },
  {
    "name": "shopping-cart",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e1e9",
    "id": 945,
    "tags": [
      "ecommerce",
      "market",
      "basket",
      "buying",
      "groceries",
      "checkout",
      "places",
      "locations"
    ]
  },
  {
    "name": "sliders-horizontal",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e1ea",
    "id": 946,
    "tags": [
      "music",
      "audio",
      "faders",
      "filters",
      "equalizer",
      "volume",
      "settings",
      "preferences"
    ]
  },
  {
    "name": "sms",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "social"
    ],
    "unicode": "e1eb",
    "id": 947,
    "tags": [
      "sms",
      "social"
    ]
  },
  {
    "name": "split-horizontal",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e1ec",
    "id": 948,
    "tags": [
      "resize",
      "columns"
    ]
  },
  {
    "name": "split-vertical",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e1ed",
    "id": 949,
    "tags": [
      "resize",
      "rows"
    ]
  },
  {
    "name": "square-split-horizontal",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e1ee",
    "id": 950,
    "tags": [
      "shapes",
      "polygons",
      "columns"
    ]
  },
  {
    "name": "square-split-vertical",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e1ef",
    "id": 951,
    "tags": [
      "shapes",
      "polygons",
      "rows"
    ]
  },
  {
    "name": "superscript",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "text-formatting"
    ],
    "unicode": "e1f0",
    "id": 952,
    "tags": [
      "superscript",
      "text-formatting"
    ]
  },
  {
    "name": "tablet",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "social"
    ],
    "unicode": "e1f1",
    "id": 953,
    "tags": [
      "tablet",
      "social"
    ]
  },
  {
    "name": "tag-chevron",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "misc"
    ],
    "unicode": "e1f2",
    "id": 954,
    "tags": [
      "tags",
      "hashtag",
      "labels",
      "sale"
    ]
  },
  {
    "name": "tag-simple",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "misc"
    ],
    "unicode": "e1f3",
    "id": 955,
    "tags": [
      "tags",
      "hashtag",
      "labels",
      "sale",
      "sell",
      "price",
      "discount"
    ]
  },
  {
    "name": "target",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "misc"
    ],
    "unicode": "e1f4",
    "id": 956,
    "tags": [
      "bullseye",
      "radar",
      "archery",
      "accuracy",
      "precision"
    ]
  },
  {
    "name": "therapist",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "misc"
    ],
    "unicode": "e1f5",
    "id": 957,
    "tags": [
      "therapist",
      "misc"
    ]
  },
  {
    "name": "tray-arrow-up",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e1f6",
    "id": 958,
    "tags": [
      "outbox",
      "archival",
      "unarchive",
      "uploaded",
      "uploading"
    ]
  },
  {
    "name": "tree-structure",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "misc"
    ],
    "unicode": "e1f7",
    "id": 959,
    "tags": [
      "data structures",
      "family tree",
      "genealogy",
      "hierarchy",
      "taxonomy",
      "charts",
      "flowchart"
    ]
  },
  {
    "name": "tree-view",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "misc"
    ],
    "unicode": "e1f8",
    "id": 960,
    "tags": [
      "hierarchy"
    ]
  },
  {
    "name": "trend-up",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "misc"
    ],
    "unicode": "e1f9",
    "id": 961,
    "tags": [
      "graphs",
      "graphing",
      "charts",
      "statistics",
      "analyze",
      "analysis",
      "increase",
      "arrows"
    ]
  },
  {
    "name": "upgrade",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e1fa",
    "id": 962,
    "tags": [
      "upgrade",
      "actions"
    ]
  },
  {
    "name": "upload-simple",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e1fb",
    "id": 963,
    "tags": [
      "saved",
      "saving",
      "archived",
      "archiving",
      "archival",
      "uploaded",
      "uploading",
      "hard drive",
      "disk"
    ]
  },
  {
    "name": "users-four",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "social"
    ],
    "unicode": "e1fc",
    "id": 964,
    "tags": [
      "user",
      "group",
      "team",
      "department",
      "community",
      "people",
      "profiles",
      "accounts",
      "contacts"
    ]
  },
  {
    "name": "users-three",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "social"
    ],
    "unicode": "e1fd",
    "id": 965,
    "tags": [
      "user",
      "group",
      "team",
      "community",
      "people",
      "profiles",
      "accounts",
      "contacts"
    ]
  },
  {
    "name": "users",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "social"
    ],
    "unicode": "e1fe",
    "id": 966,
    "tags": [
      "user",
      "group",
      "team",
      "people",
      "profiles",
      "accounts",
      "contacts"
    ]
  },
  {
    "name": "vault",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "misc"
    ],
    "unicode": "e1ff",
    "id": 967,
    "tags": [
      "safe",
      "bank",
      "security",
      "secured",
      "authentication",
      "authenticated",
      "locked",
      "encrypted",
      "encryption"
    ]
  },
  {
    "name": "reorder",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "layout"
    ],
    "unicode": "e200",
    "id": 1302,
    "tags": [
      "reorder",
      "layout"
    ]
  },
  {
    "name": "replace-all",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "text-formatting"
    ],
    "unicode": "e201",
    "id": 1303,
    "tags": [
      "replace",
      "all",
      "text-formatting"
    ]
  },
  {
    "name": "replace-free-text",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e202",
    "id": 1304,
    "tags": [
      "replace",
      "free",
      "text",
      "editing",
      "typography",
      "font",
      "writing"
    ]
  },
  {
    "name": "replace-single",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "text-formatting"
    ],
    "unicode": "e203",
    "id": 1305,
    "tags": [
      "replace",
      "single",
      "text-formatting"
    ]
  },
  {
    "name": "report-element",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "text-formatting"
    ],
    "unicode": "e204",
    "id": 1306,
    "tags": [
      "report",
      "element",
      "text-formatting"
    ]
  },
  {
    "name": "rewind",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "media"
    ],
    "unicode": "e205",
    "id": 1307,
    "tags": [
      "music",
      "audio",
      "seek",
      "scrub",
      "scan",
      "skip",
      "back",
      "backwards",
      "reverse"
    ]
  },
  {
    "name": "right-double-quotes",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "text-formatting"
    ],
    "unicode": "e206",
    "id": 1308,
    "tags": [
      "right",
      "double",
      "quotes",
      "text-formatting"
    ]
  },
  {
    "name": "rotate-left",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "images"
    ],
    "unicode": "e207",
    "id": 1309,
    "tags": [
      "rotate",
      "left",
      "images",
      "turn",
      "spin",
      "orientation"
    ]
  },
  {
    "name": "rotate-right",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "images"
    ],
    "unicode": "e208",
    "id": 1310,
    "tags": [
      "rotate",
      "right",
      "images",
      "turn",
      "spin",
      "orientation"
    ]
  },
  {
    "name": "rotate",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "images"
    ],
    "unicode": "e209",
    "id": 1311,
    "tags": [
      "rotate",
      "images",
      "turn",
      "spin",
      "orientation"
    ]
  },
  {
    "name": "row-collapse",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e20a",
    "id": 1312,
    "tags": [
      "row",
      "collapse",
      "editing"
    ]
  },
  {
    "name": "row-expand",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e20b",
    "id": 1313,
    "tags": [
      "row",
      "expand",
      "editing"
    ]
  },
  {
    "name": "rows",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "layout"
    ],
    "unicode": "e20c",
    "id": 1314,
    "tags": [
      "2",
      "shapes",
      "polygons",
      "box",
      "stack",
      "list",
      "table",
      "cards"
    ]
  },
  {
    "name": "rss",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "social"
    ],
    "unicode": "e20d",
    "id": 1315,
    "tags": [
      "radio",
      "broadcast",
      "web feed",
      "news",
      "aggregator"
    ]
  },
  {
    "name": "save",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e20e",
    "id": 1316,
    "tags": [
      "save",
      "actions",
      "disk",
      "floppy",
      "store"
    ]
  },
  {
    "name": "wallet",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "misc"
    ],
    "unicode": "e20f",
    "id": 968,
    "tags": [
      "money",
      "payment",
      "paying",
      "purchase"
    ]
  },
  {
    "name": "weight-scale",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "misc"
    ],
    "unicode": "e210",
    "id": 969,
    "tags": [
      "weight",
      "scale",
      "misc"
    ]
  },
  {
    "name": "scale",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e211",
    "id": 1317,
    "tags": [
      "scale",
      "actions"
    ]
  },
  {
    "name": "search",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e212",
    "id": 1318,
    "tags": [
      "search",
      "actions",
      "find",
      "lookup",
      "magnify"
    ]
  },
  {
    "name": "select-all",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e213",
    "id": 1319,
    "tags": [
      "select",
      "all",
      "editing",
      "dropdown",
      "choose",
      "pick"
    ]
  },
  {
    "name": "select-box",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e214",
    "id": 1320,
    "tags": [
      "select",
      "box",
      "editing",
      "dropdown",
      "choose",
      "pick",
      "container",
      "package",
      "cube"
    ]
  },
  {
    "name": "set-column-position",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e215",
    "id": 1321,
    "tags": [
      "set",
      "column",
      "position",
      "actions"
    ]
  },
  {
    "name": "shape-line",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "images"
    ],
    "unicode": "e216",
    "id": 1322,
    "tags": [
      "shape",
      "line",
      "images",
      "form",
      "polygon",
      "geometry",
      "chart",
      "graph",
      "trend"
    ]
  },
  {
    "name": "shapes",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "images"
    ],
    "unicode": "e217",
    "id": 1323,
    "tags": [
      "geometry",
      "square",
      "circle",
      "triangle"
    ]
  },
  {
    "name": "share",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "social"
    ],
    "unicode": "e218",
    "id": 1324,
    "tags": [
      "send to",
      "export",
      "arrows"
    ]
  },
  {
    "name": "sharpen",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "images"
    ],
    "unicode": "e219",
    "id": 1325,
    "tags": [
      "sharpen",
      "images"
    ]
  },
  {
    "name": "signature",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e21a",
    "id": 1326,
    "tags": [
      "sign",
      "autograph",
      "verify"
    ]
  },
  {
    "name": "sliders",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "images"
    ],
    "unicode": "e21b",
    "id": 1327,
    "tags": [
      "music",
      "audio",
      "faders",
      "filters",
      "equalizer",
      "volume",
      "settings",
      "preferences"
    ]
  },
  {
    "name": "sln",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "files-and-folders"
    ],
    "unicode": "e21c",
    "id": 1328,
    "tags": [
      "sln",
      "files-and-folders"
    ]
  },
  {
    "name": "snap-to-gridlines",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e21d",
    "id": 1329,
    "tags": [
      "snap",
      "to",
      "gridlines",
      "editing"
    ]
  },
  {
    "name": "sort-asc-small",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e21e",
    "id": 1330,
    "tags": [
      "sort",
      "asc",
      "small",
      "actions",
      "order",
      "arrange"
    ]
  },
  {
    "name": "sort-asc",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e21f",
    "id": 1331,
    "tags": [
      "sort",
      "asc",
      "actions",
      "order",
      "arrange"
    ]
  },
  {
    "name": "sort-clear",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e220",
    "id": 1332,
    "tags": [
      "sort",
      "clear",
      "actions",
      "order",
      "arrange"
    ]
  },
  {
    "name": "sort-desc-small",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e221",
    "id": 1333,
    "tags": [
      "sort",
      "desc",
      "small",
      "actions",
      "order",
      "arrange"
    ]
  },
  {
    "name": "sort-desc",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e222",
    "id": 1334,
    "tags": [
      "sort",
      "desc",
      "actions",
      "order",
      "arrange"
    ]
  },
  {
    "name": "sparkles",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "misc"
    ],
    "unicode": "e223",
    "id": 1335,
    "tags": [
      "sparkles",
      "misc"
    ]
  },
  {
    "name": "speed",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "misc"
    ],
    "unicode": "e224",
    "id": 1336,
    "tags": [
      "speed",
      "misc"
    ]
  },
  {
    "name": "spell-checker",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e225",
    "id": 1337,
    "tags": [
      "spell",
      "checker",
      "editing"
    ]
  },
  {
    "name": "stamp",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e226",
    "id": 1338,
    "tags": [
      "clone",
      "seal",
      "official"
    ]
  },
  {
    "name": "star",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "toggle"
    ],
    "unicode": "e227",
    "id": 1339,
    "tags": [
      "rate",
      "ratings",
      "favorites",
      "favorited"
    ]
  },
  {
    "name": "stick",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e228",
    "id": 1340,
    "tags": [
      "stick",
      "actions"
    ]
  },
  {
    "name": "sticky-note",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e229",
    "id": 1341,
    "tags": [
      "sticky",
      "note",
      "editing"
    ]
  },
  {
    "name": "stop",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "media"
    ],
    "unicode": "e22a",
    "id": 1342,
    "tags": [
      "music",
      "audio"
    ]
  },
  {
    "name": "strikethrough",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "text-formatting"
    ],
    "unicode": "e22b",
    "id": 1343,
    "tags": [
      "strikethrough",
      "text-formatting",
      "text",
      "delete"
    ]
  },
  {
    "name": "strip-all-formatting",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e22c",
    "id": 1344,
    "tags": [
      "strip",
      "all",
      "formatting",
      "editing"
    ]
  },
  {
    "name": "strip-css-format",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e22d",
    "id": 1345,
    "tags": [
      "strip",
      "css",
      "format",
      "editing",
      "style",
      "design",
      "web"
    ]
  },
  {
    "name": "strip-font-elements",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e22e",
    "id": 1346,
    "tags": [
      "strip",
      "font",
      "elements",
      "editing"
    ]
  },
  {
    "name": "strip-span-elements",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e22f",
    "id": 1347,
    "tags": [
      "strip",
      "span",
      "elements",
      "editing"
    ]
  },
  {
    "name": "strip-word-formatting",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e230",
    "id": 1348,
    "tags": [
      "strip",
      "word",
      "formatting",
      "editing",
      "document",
      "doc",
      "text"
    ]
  },
  {
    "name": "subreport",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "files-and-folders"
    ],
    "unicode": "e231",
    "id": 1349,
    "tags": [
      "subreport",
      "files-and-folders"
    ]
  },
  {
    "name": "subscript",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "text-formatting"
    ],
    "unicode": "e232",
    "id": 1350,
    "tags": [
      "subscript",
      "text-formatting"
    ]
  },
  {
    "name": "sum",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e233",
    "id": 1351,
    "tags": [
      "sum",
      "editing",
      "total",
      "add",
      "calculate"
    ]
  },
  {
    "name": "sustainability",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "misc"
    ],
    "unicode": "e234",
    "id": 1352,
    "tags": [
      "sustainability",
      "misc"
    ]
  },
  {
    "name": "sweeper-vehicle",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "misc"
    ],
    "unicode": "e235",
    "id": 1353,
    "tags": [
      "sweeper",
      "vehicle",
      "misc"
    ]
  },
  {
    "name": "symbol",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e236",
    "id": 1354,
    "tags": [
      "symbol",
      "editing"
    ]
  },
  {
    "name": "table-align-middle-center",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "text-formatting"
    ],
    "unicode": "e237",
    "id": 1355,
    "tags": [
      "table",
      "align",
      "middle",
      "center",
      "text-formatting",
      "grid",
      "spreadsheet",
      "data",
      "position",
      "arrange",
      "layout"
    ]
  },
  {
    "name": "table-delete",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e238",
    "id": 1356,
    "tags": [
      "table",
      "delete",
      "editing",
      "grid",
      "spreadsheet",
      "data",
      "remove",
      "trash",
      "destroy"
    ]
  },
  {
    "name": "table-unmerge",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e239",
    "id": 1357,
    "tags": [
      "table",
      "unmerge",
      "editing",
      "grid",
      "spreadsheet",
      "data"
    ]
  },
  {
    "name": "tell-a-friend",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "social"
    ],
    "unicode": "e23a",
    "id": 1358,
    "tags": [
      "tell",
      "a",
      "friend",
      "social"
    ]
  },
  {
    "name": "template-manager",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e23b",
    "id": 1359,
    "tags": [
      "template",
      "manager",
      "editing"
    ]
  },
  {
    "name": "text-truncate",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "text-formatting"
    ],
    "unicode": "e23c",
    "id": 1360,
    "tags": [
      "text",
      "truncate",
      "text-formatting",
      "typography",
      "font",
      "writing"
    ]
  },
  {
    "name": "text-wrap-arrow",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "text-formatting"
    ],
    "unicode": "e23d",
    "id": 1361,
    "tags": [
      "text",
      "wrap",
      "arrow",
      "text-formatting",
      "typography",
      "font",
      "writing",
      "direction",
      "navigate",
      "pointer"
    ]
  },
  {
    "name": "textarea",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e23e",
    "id": 1362,
    "tags": [
      "textarea",
      "editing"
    ]
  },
  {
    "name": "textbox-hidden",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e23f",
    "id": 1363,
    "tags": [
      "textbox",
      "hidden",
      "editing"
    ]
  },
  {
    "name": "textbox",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e240",
    "id": 1364,
    "tags": [
      "input",
      "cursor",
      "field"
    ]
  },
  {
    "name": "thumb-down",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "toggle"
    ],
    "unicode": "e241",
    "id": 1365,
    "tags": [
      "thumb",
      "down",
      "toggle"
    ]
  },
  {
    "name": "thumb-up",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "toggle"
    ],
    "unicode": "e242",
    "id": 1366,
    "tags": [
      "thumb",
      "up",
      "toggle"
    ]
  },
  {
    "name": "toggle-full-screen-mode",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e243",
    "id": 1367,
    "tags": [
      "toggle",
      "full",
      "screen",
      "mode",
      "editing",
      "switch",
      "on",
      "off"
    ]
  },
  {
    "name": "toolbar-float",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e244",
    "id": 1368,
    "tags": [
      "toolbar",
      "float",
      "editing"
    ]
  },
  {
    "name": "transactions",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "misc"
    ],
    "unicode": "e245",
    "id": 1369,
    "tags": [
      "transactions",
      "misc"
    ]
  },
  {
    "name": "transparency",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "images"
    ],
    "unicode": "e246",
    "id": 1370,
    "tags": [
      "transparency",
      "images"
    ]
  },
  {
    "name": "trash",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e247",
    "id": 1371,
    "tags": [
      "garbage",
      "remove",
      "delete",
      "destroy",
      "recycle",
      "recycling"
    ]
  },
  {
    "name": "truck",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "misc"
    ],
    "unicode": "e248",
    "id": 1372,
    "tags": [
      "trucks",
      "cars",
      "vehicles",
      "automobile",
      "shipping",
      "delivery"
    ]
  },
  {
    "name": "tumblr",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "social"
    ],
    "unicode": "e249",
    "id": 1373,
    "tags": [
      "tumblr",
      "social"
    ]
  },
  {
    "name": "underline",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "text-formatting"
    ],
    "unicode": "e24a",
    "id": 1374,
    "tags": [
      "underline",
      "text-formatting",
      "text",
      "decoration"
    ]
  },
  {
    "name": "undo",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e24b",
    "id": 1375,
    "tags": [
      "undo",
      "actions",
      "revert",
      "back"
    ]
  },
  {
    "name": "ungroup",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "layout"
    ],
    "unicode": "e24c",
    "id": 1376,
    "tags": [
      "ungroup",
      "layout",
      "separate",
      "split",
      "divide"
    ]
  },
  {
    "name": "unlink-vertical",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e24d",
    "id": 1377,
    "tags": [
      "unlink",
      "vertical",
      "actions",
      "break",
      "disconnect"
    ]
  },
  {
    "name": "unlink",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e24e",
    "id": 1378,
    "tags": [
      "unlink",
      "actions",
      "break",
      "disconnect"
    ]
  },
  {
    "name": "unlock",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e24f",
    "id": 1379,
    "tags": [
      "unlock",
      "actions",
      "open",
      "public"
    ]
  },
  {
    "name": "unpin",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "maps"
    ],
    "unicode": "e250",
    "id": 1380,
    "tags": [
      "unpin",
      "maps"
    ]
  },
  {
    "name": "unstick",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e251",
    "id": 1381,
    "tags": [
      "unstick",
      "actions"
    ]
  },
  {
    "name": "upgrade-reload",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e252",
    "id": 1382,
    "tags": [
      "upgrade",
      "reload",
      "actions"
    ]
  },
  {
    "name": "upload",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e253",
    "id": 1383,
    "tags": [
      "saved",
      "saving",
      "archived",
      "archiving",
      "archival",
      "uploaded",
      "uploading",
      "hard drive",
      "disk"
    ]
  },
  {
    "name": "user",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "social"
    ],
    "unicode": "e254",
    "id": 1384,
    "tags": [
      "person",
      "users",
      "profile",
      "account",
      "contact",
      "login"
    ]
  },
  {
    "name": "validation-data",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e255",
    "id": 1385,
    "tags": [
      "validation",
      "data",
      "editing"
    ]
  },
  {
    "name": "validation-xhtml",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e256",
    "id": 1386,
    "tags": [
      "validation",
      "xhtml",
      "editing"
    ]
  },
  {
    "name": "van",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "misc"
    ],
    "unicode": "e257",
    "id": 1387,
    "tags": [
      "westfalia",
      "microbus",
      "vanagon",
      "cars",
      "vehicles",
      "automobile",
      "transit",
      "transportation",
      "traveling"
    ]
  },
  {
    "name": "vb",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "files-and-folders"
    ],
    "unicode": "e258",
    "id": 1388,
    "tags": [
      "vb",
      "files-and-folders"
    ]
  },
  {
    "name": "vbproj",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "files-and-folders"
    ],
    "unicode": "e259",
    "id": 1389,
    "tags": [
      "vbproj",
      "files-and-folders"
    ]
  },
  {
    "name": "video-external",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "media"
    ],
    "unicode": "e25a",
    "id": 1390,
    "tags": [
      "video",
      "external",
      "media",
      "movie",
      "film"
    ]
  },
  {
    "name": "vimeo",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "social"
    ],
    "unicode": "e25b",
    "id": 1391,
    "tags": [
      "vimeo",
      "social"
    ]
  },
  {
    "name": "volume-down",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "media"
    ],
    "unicode": "e25c",
    "id": 1392,
    "tags": [
      "volume",
      "down",
      "media",
      "sound",
      "audio",
      "speaker"
    ]
  },
  {
    "name": "volume-mute",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "media"
    ],
    "unicode": "e25d",
    "id": 1393,
    "tags": [
      "volume",
      "mute",
      "media",
      "sound",
      "audio",
      "speaker"
    ]
  },
  {
    "name": "volume-up",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "media"
    ],
    "unicode": "e25e",
    "id": 1394,
    "tags": [
      "volume",
      "up",
      "media",
      "sound",
      "audio",
      "speaker"
    ]
  },
  {
    "name": "warning-circle",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "alerts",
      "notifications"
    ],
    "unicode": "e25f",
    "id": 1395,
    "tags": [
      "alert",
      "danger",
      "dangerous",
      "caution",
      "errors",
      "round"
    ]
  },
  {
    "name": "warning-triangle",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "alerts",
      "notifications"
    ],
    "unicode": "e260",
    "id": 1396,
    "tags": [
      "warning",
      "triangle",
      "alerts",
      "notifications",
      "alert",
      "caution",
      "danger"
    ]
  },
  {
    "name": "whatsapp",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "social"
    ],
    "unicode": "e261",
    "id": 1397,
    "tags": [
      "whatsapp",
      "social"
    ]
  },
  {
    "name": "whole-word",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "text-formatting"
    ],
    "unicode": "e262",
    "id": 1398,
    "tags": [
      "whole",
      "word",
      "text-formatting",
      "document",
      "doc",
      "text"
    ]
  },
  {
    "name": "window-minimize",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e263",
    "id": 1399,
    "tags": [
      "window",
      "minimize",
      "actions",
      "app",
      "panel",
      "frame"
    ]
  },
  {
    "name": "window-restore",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e264",
    "id": 1400,
    "tags": [
      "window",
      "restore",
      "actions",
      "app",
      "panel",
      "frame"
    ]
  },
  {
    "name": "window",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e265",
    "id": 1401,
    "tags": [
      "window",
      "actions",
      "app",
      "panel",
      "frame"
    ]
  },
  {
    "name": "wrench",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e266",
    "id": 1402,
    "tags": [
      "settings",
      "setup",
      "preferences",
      "tools",
      "machinery",
      "mechanical",
      "repairs"
    ]
  },
  {
    "name": "x-circle",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e267",
    "id": 1403,
    "tags": [
      "closed",
      "cancelled",
      "dismissed",
      "round"
    ]
  },
  {
    "name": "x-logo",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "social"
    ],
    "unicode": "e268",
    "id": 1404,
    "tags": [
      "twitter",
      "logos",
      "social media",
      "tweets"
    ]
  },
  {
    "name": "x",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e269",
    "id": 1405,
    "tags": [
      "Ã—",
      "closed",
      "cancelled",
      "dismissed",
      "times",
      "multiply",
      "mulitplication",
      "product",
      "mathematics",
      "arithmetic",
      "calculator"
    ]
  },
  {
    "name": "yammer",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "social"
    ],
    "unicode": "e26a",
    "id": 1406,
    "tags": [
      "yammer",
      "social"
    ]
  },
  {
    "name": "youtube",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "social"
    ],
    "unicode": "e26b",
    "id": 1407,
    "tags": [
      "youtube",
      "social"
    ]
  },
  {
    "name": "zoom-actual-size",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "images"
    ],
    "unicode": "e26c",
    "id": 1408,
    "tags": [
      "zoom",
      "actual",
      "size",
      "images",
      "magnify",
      "scale"
    ]
  },
  {
    "name": "zoom-best-fit",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "images"
    ],
    "unicode": "e26d",
    "id": 1409,
    "tags": [
      "zoom",
      "best",
      "fit",
      "images",
      "magnify",
      "scale"
    ]
  },
  {
    "name": "zoom-in",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e26e",
    "id": 1410,
    "tags": [
      "zoom",
      "in",
      "actions",
      "magnify",
      "scale"
    ]
  },
  {
    "name": "zoom-out",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e26f",
    "id": 1411,
    "tags": [
      "zoom",
      "out",
      "actions",
      "magnify",
      "scale"
    ]
  },
  {
    "name": "zoom-sparkle",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "actions"
    ],
    "unicode": "e270",
    "id": 1412,
    "tags": [
      "zoom",
      "sparkle",
      "actions",
      "magnify",
      "scale"
    ]
  },
  {
    "name": "checkbox-null",
    "ligatures": [],
    "aliases": [
      "tri-state-null"
    ],
    "categories": [
      "toggle"
    ],
    "unicode": "e307",
    "id": 227,
    "tags": [
      "checkbox",
      "null",
      "tri",
      "state",
      "toggle",
      "check",
      "form"
    ]
  },
  {
    "name": "image-export",
    "ligatures": [],
    "aliases": [
      "photo-export"
    ],
    "categories": [
      "images"
    ],
    "unicode": "e502",
    "id": 237,
    "tags": [
      "image",
      "export",
      "photo",
      "images",
      "picture",
      "gallery",
      "download",
      "save",
      "output"
    ]
  },
  {
    "name": "round-corners",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "images"
    ],
    "unicode": "e519",
    "id": 260,
    "tags": [
      "round",
      "corners",
      "images"
    ]
  },
  {
    "name": "bring-to-front",
    "ligatures": [],
    "aliases": [
      "front-element"
    ],
    "categories": [
      "editing"
    ],
    "unicode": "e51a",
    "id": 261,
    "tags": [
      "bring",
      "to",
      "front",
      "element",
      "editing"
    ]
  },
  {
    "name": "bring-to-back",
    "ligatures": [],
    "aliases": [
      "back-element"
    ],
    "categories": [
      "editing"
    ],
    "unicode": "e51b",
    "id": 262,
    "tags": [
      "bring",
      "to",
      "back",
      "element",
      "editing"
    ]
  },
  {
    "name": "bring-forward",
    "ligatures": [],
    "aliases": [
      "forward-element"
    ],
    "categories": [
      "editing"
    ],
    "unicode": "e51c",
    "id": 263,
    "tags": [
      "bring",
      "forward",
      "element",
      "editing",
      "next",
      "skip",
      "ahead"
    ]
  },
  {
    "name": "bring-backward",
    "ligatures": [],
    "aliases": [
      "backward-element"
    ],
    "categories": [
      "editing"
    ],
    "unicode": "e51d",
    "id": 264,
    "tags": [
      "bring",
      "backward",
      "element",
      "editing",
      "previous",
      "back",
      "rewind"
    ]
  },
  {
    "name": "align-self-start",
    "ligatures": [],
    "aliases": [
      "align-left-element"
    ],
    "categories": [
      "editing"
    ],
    "unicode": "e51e",
    "id": 265,
    "tags": [
      "align",
      "self",
      "start",
      "left",
      "element",
      "editing",
      "position",
      "arrange",
      "layout"
    ]
  },
  {
    "name": "align-self-center",
    "ligatures": [],
    "aliases": [
      "align-center-element"
    ],
    "categories": [
      "editing"
    ],
    "unicode": "e51f",
    "id": 266,
    "tags": [
      "align",
      "self",
      "center",
      "element",
      "editing",
      "position",
      "arrange",
      "layout"
    ]
  },
  {
    "name": "align-self-end",
    "ligatures": [],
    "aliases": [
      "align-right-element"
    ],
    "categories": [
      "editing"
    ],
    "unicode": "e520",
    "id": 267,
    "tags": [
      "align",
      "self",
      "end",
      "right",
      "element",
      "editing",
      "position",
      "arrange",
      "layout"
    ]
  },
  {
    "name": "align-self-start-alt",
    "ligatures": [],
    "aliases": [
      "align-top-element"
    ],
    "categories": [
      "editing"
    ],
    "unicode": "e521",
    "id": 268,
    "tags": [
      "align",
      "self",
      "start",
      "alt",
      "top",
      "element",
      "editing",
      "position",
      "arrange",
      "layout"
    ]
  },
  {
    "name": "align-self-center-alt",
    "ligatures": [],
    "aliases": [
      "align-middle-element"
    ],
    "categories": [
      "editing"
    ],
    "unicode": "e522",
    "id": 269,
    "tags": [
      "align",
      "self",
      "center",
      "alt",
      "middle",
      "element",
      "editing",
      "position",
      "arrange",
      "layout"
    ]
  },
  {
    "name": "align-self-end-alt",
    "ligatures": [],
    "aliases": [
      "align-bottom-element"
    ],
    "categories": [
      "editing"
    ],
    "unicode": "e523",
    "id": 270,
    "tags": [
      "align",
      "self",
      "end",
      "alt",
      "bottom",
      "element",
      "editing",
      "position",
      "arrange",
      "layout"
    ]
  },
  {
    "name": "thumbnails-up",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e524",
    "id": 271,
    "tags": [
      "thumbnails",
      "up",
      "editing"
    ]
  },
  {
    "name": "thumbnails-right",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e525",
    "id": 272,
    "tags": [
      "thumbnails",
      "right",
      "editing"
    ]
  },
  {
    "name": "thumbnails-down",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e526",
    "id": 273,
    "tags": [
      "thumbnails",
      "down",
      "editing"
    ]
  },
  {
    "name": "thumbnails-left",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e527",
    "id": 274,
    "tags": [
      "thumbnails",
      "left",
      "editing"
    ]
  },
  {
    "name": "align-to-grid",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e52c",
    "id": 279,
    "tags": [
      "align",
      "to",
      "grid",
      "editing",
      "position",
      "arrange",
      "layout",
      "tiles",
      "view"
    ]
  },
  {
    "name": "size-to-grid",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e52d",
    "id": 280,
    "tags": [
      "size",
      "to",
      "grid",
      "editing",
      "layout",
      "tiles",
      "view"
    ]
  },
  {
    "name": "make-same-size",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e52e",
    "id": 281,
    "tags": [
      "make",
      "same",
      "size",
      "editing"
    ]
  },
  {
    "name": "make-same-width",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e52f",
    "id": 282,
    "tags": [
      "make",
      "same",
      "width",
      "editing"
    ]
  },
  {
    "name": "make-same-height",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e530",
    "id": 283,
    "tags": [
      "make",
      "same",
      "height",
      "editing"
    ]
  },
  {
    "name": "snap-grid",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e53a",
    "id": 293,
    "tags": [
      "snap",
      "grid",
      "editing",
      "layout",
      "tiles",
      "view"
    ]
  },
  {
    "name": "snap-to-snaplines",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e53c",
    "id": 295,
    "tags": [
      "snap",
      "to",
      "snaplines",
      "editing"
    ]
  },
  {
    "name": "align-self-stretch",
    "ligatures": [],
    "aliases": [
      "align-stretch-element-horizontal"
    ],
    "categories": [
      "editing"
    ],
    "unicode": "e53e",
    "id": 297,
    "tags": [
      "align",
      "self",
      "stretch",
      "element",
      "horizontal",
      "editing",
      "position",
      "arrange",
      "layout"
    ]
  },
  {
    "name": "align-self-stretch-alt",
    "ligatures": [],
    "aliases": [
      "align-stretch-element-vertical"
    ],
    "categories": [
      "editing"
    ],
    "unicode": "e53f",
    "id": 298,
    "tags": [
      "align",
      "self",
      "stretch",
      "alt",
      "element",
      "vertical",
      "editing",
      "position",
      "arrange",
      "layout"
    ]
  },
  {
    "name": "align-items-stretch",
    "ligatures": [],
    "aliases": [
      "align-stretch-elements-horizontal"
    ],
    "categories": [
      "editing"
    ],
    "unicode": "e543",
    "id": 302,
    "tags": [
      "align",
      "items",
      "stretch",
      "elements",
      "horizontal",
      "editing",
      "position",
      "arrange",
      "layout"
    ]
  },
  {
    "name": "align-items-baseline",
    "ligatures": [],
    "aliases": [
      "align-baseline-horizontal"
    ],
    "categories": [
      "editing"
    ],
    "unicode": "e544",
    "id": 303,
    "tags": [
      "align",
      "items",
      "baseline",
      "horizontal",
      "editing",
      "position",
      "arrange",
      "layout"
    ]
  },
  {
    "name": "align-items-stretch-alt",
    "ligatures": [],
    "aliases": [
      "align-stretch-elements-vertical"
    ],
    "categories": [
      "editing"
    ],
    "unicode": "e548",
    "id": 307,
    "tags": [
      "align",
      "items",
      "stretch",
      "alt",
      "elements",
      "vertical",
      "editing",
      "position",
      "arrange",
      "layout"
    ]
  },
  {
    "name": "align-items-baseline-alt",
    "ligatures": [],
    "aliases": [
      "align-baseline-vertical"
    ],
    "categories": [
      "editing"
    ],
    "unicode": "e549",
    "id": 308,
    "tags": [
      "align",
      "items",
      "baseline",
      "alt",
      "vertical",
      "editing",
      "position",
      "arrange",
      "layout"
    ]
  },
  {
    "name": "justify-content-start",
    "ligatures": [],
    "aliases": [
      "justify-start-horizontal"
    ],
    "categories": [
      "editing"
    ],
    "unicode": "e54a",
    "id": 309,
    "tags": [
      "justify",
      "content",
      "start",
      "horizontal",
      "editing"
    ]
  },
  {
    "name": "justify-content-center",
    "ligatures": [],
    "aliases": [
      "justify-center-horizontal"
    ],
    "categories": [
      "editing"
    ],
    "unicode": "e54b",
    "id": 310,
    "tags": [
      "justify",
      "content",
      "center",
      "horizontal",
      "editing"
    ]
  },
  {
    "name": "justify-content-end",
    "ligatures": [],
    "aliases": [
      "justify-end-horizontal"
    ],
    "categories": [
      "editing"
    ],
    "unicode": "e54c",
    "id": 311,
    "tags": [
      "justify",
      "content",
      "end",
      "horizontal",
      "editing"
    ]
  },
  {
    "name": "justify-content-between",
    "ligatures": [],
    "aliases": [
      "justify-between-horizontal"
    ],
    "categories": [
      "editing"
    ],
    "unicode": "e54d",
    "id": 312,
    "tags": [
      "justify",
      "content",
      "between",
      "horizontal",
      "editing"
    ]
  },
  {
    "name": "justify-content-around",
    "ligatures": [],
    "aliases": [
      "justify-around-horizontal"
    ],
    "categories": [
      "editing"
    ],
    "unicode": "e54e",
    "id": 313,
    "tags": [
      "justify",
      "content",
      "around",
      "horizontal",
      "editing"
    ]
  },
  {
    "name": "justify-content-start-alt",
    "ligatures": [],
    "aliases": [
      "justify-start-vertical"
    ],
    "categories": [
      "editing"
    ],
    "unicode": "e54f",
    "id": 314,
    "tags": [
      "justify",
      "content",
      "start",
      "alt",
      "vertical",
      "editing"
    ]
  },
  {
    "name": "justify-content-center-alt",
    "ligatures": [],
    "aliases": [
      "justify-center-vertical"
    ],
    "categories": [
      "editing"
    ],
    "unicode": "e550",
    "id": 315,
    "tags": [
      "justify",
      "content",
      "center",
      "alt",
      "vertical",
      "editing"
    ]
  },
  {
    "name": "justify-content-end-alt",
    "ligatures": [],
    "aliases": [
      "justify-end-vertical"
    ],
    "categories": [
      "editing"
    ],
    "unicode": "e551",
    "id": 316,
    "tags": [
      "justify",
      "content",
      "end",
      "alt",
      "vertical",
      "editing"
    ]
  },
  {
    "name": "justify-content-between-alt",
    "ligatures": [],
    "aliases": [
      "justify-between-vertical"
    ],
    "categories": [
      "editing"
    ],
    "unicode": "e552",
    "id": 317,
    "tags": [
      "justify",
      "content",
      "between",
      "alt",
      "vertical",
      "editing"
    ]
  },
  {
    "name": "justify-content-around-alt",
    "ligatures": [],
    "aliases": [
      "justify-around-vertical"
    ],
    "categories": [
      "editing"
    ],
    "unicode": "e553",
    "id": 318,
    "tags": [
      "justify",
      "content",
      "around",
      "alt",
      "vertical",
      "editing"
    ]
  },
  {
    "name": "file-wrench",
    "ligatures": [],
    "aliases": [
      "page-properties"
    ],
    "categories": [
      "editing"
    ],
    "unicode": "e600",
    "id": 319,
    "tags": [
      "file",
      "wrench",
      "page",
      "properties",
      "editing",
      "document",
      "paper",
      "tool",
      "repair",
      "fix",
      "settings"
    ]
  },
  {
    "name": "foreground-color",
    "ligatures": [],
    "aliases": [
      "text"
    ],
    "categories": [
      "text-formatting"
    ],
    "unicode": "e605",
    "id": 324,
    "tags": [
      "foreground",
      "color",
      "text",
      "text-formatting",
      "paint",
      "palette",
      "fill"
    ]
  },
  {
    "name": "align-remove",
    "ligatures": [],
    "aliases": [
      "justify-clear"
    ],
    "categories": [
      "text-formatting"
    ],
    "unicode": "e621",
    "id": 352,
    "tags": [
      "align",
      "remove",
      "justify",
      "clear",
      "text-formatting",
      "position",
      "arrange",
      "layout",
      "delete",
      "minus",
      "subtract"
    ]
  },
  {
    "name": "horizontal-rule",
    "ligatures": [],
    "aliases": [
      "rule-horizontal",
      "hr"
    ],
    "categories": [
      "text-formatting"
    ],
    "unicode": "e623",
    "id": 354,
    "tags": [
      "horizontal",
      "rule",
      "hr",
      "text-formatting"
    ]
  },
  {
    "name": "table-align-top-left",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "text-formatting"
    ],
    "unicode": "e624",
    "id": 355,
    "tags": [
      "table",
      "align",
      "top",
      "left",
      "text-formatting",
      "grid",
      "spreadsheet",
      "data",
      "position",
      "arrange",
      "layout"
    ]
  },
  {
    "name": "table-align-top-center",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "text-formatting"
    ],
    "unicode": "e625",
    "id": 356,
    "tags": [
      "table",
      "align",
      "top",
      "center",
      "text-formatting",
      "grid",
      "spreadsheet",
      "data",
      "position",
      "arrange",
      "layout"
    ]
  },
  {
    "name": "table-align-top-right",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "text-formatting"
    ],
    "unicode": "e626",
    "id": 357,
    "tags": [
      "table",
      "align",
      "top",
      "right",
      "text-formatting",
      "grid",
      "spreadsheet",
      "data",
      "position",
      "arrange",
      "layout"
    ]
  },
  {
    "name": "table-align-middle-left",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "text-formatting"
    ],
    "unicode": "e627",
    "id": 358,
    "tags": [
      "table",
      "align",
      "middle",
      "left",
      "text-formatting",
      "grid",
      "spreadsheet",
      "data",
      "position",
      "arrange",
      "layout"
    ]
  },
  {
    "name": "table-align-middle-right",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "text-formatting"
    ],
    "unicode": "e629",
    "id": 360,
    "tags": [
      "table",
      "align",
      "middle",
      "right",
      "text-formatting",
      "grid",
      "spreadsheet",
      "data",
      "position",
      "arrange",
      "layout"
    ]
  },
  {
    "name": "table-align-bottom-left",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "text-formatting"
    ],
    "unicode": "e62a",
    "id": 361,
    "tags": [
      "table",
      "align",
      "bottom",
      "left",
      "text-formatting",
      "grid",
      "spreadsheet",
      "data",
      "position",
      "arrange",
      "layout"
    ]
  },
  {
    "name": "table-align-bottom-center",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "text-formatting"
    ],
    "unicode": "e62b",
    "id": 362,
    "tags": [
      "table",
      "align",
      "bottom",
      "center",
      "text-formatting",
      "grid",
      "spreadsheet",
      "data",
      "position",
      "arrange",
      "layout"
    ]
  },
  {
    "name": "table-align-bottom-right",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "text-formatting"
    ],
    "unicode": "e62c",
    "id": 363,
    "tags": [
      "table",
      "align",
      "bottom",
      "right",
      "text-formatting",
      "grid",
      "spreadsheet",
      "data",
      "position",
      "arrange",
      "layout"
    ]
  },
  {
    "name": "table-align-remove",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "text-formatting"
    ],
    "unicode": "e62d",
    "id": 364,
    "tags": [
      "table",
      "align",
      "remove",
      "text-formatting",
      "grid",
      "spreadsheet",
      "data",
      "position",
      "arrange",
      "layout",
      "delete",
      "minus",
      "subtract"
    ]
  },
  {
    "name": "borders-all",
    "ligatures": [],
    "aliases": [
      "all-borders"
    ],
    "categories": [
      "text-formatting"
    ],
    "unicode": "e62e",
    "id": 365,
    "tags": [
      "borders",
      "all",
      "text-formatting"
    ]
  },
  {
    "name": "borders-outside",
    "ligatures": [],
    "aliases": [
      "outside-borders"
    ],
    "categories": [
      "text-formatting"
    ],
    "unicode": "e62f",
    "id": 366,
    "tags": [
      "borders",
      "outside",
      "text-formatting"
    ]
  },
  {
    "name": "borders-inside",
    "ligatures": [],
    "aliases": [
      "inside-borders"
    ],
    "categories": [
      "text-formatting"
    ],
    "unicode": "e630",
    "id": 367,
    "tags": [
      "borders",
      "inside",
      "text-formatting"
    ]
  },
  {
    "name": "borders-inside-horizontal",
    "ligatures": [],
    "aliases": [
      "border-inside-h",
      "inside-horizontal-borders"
    ],
    "categories": [
      "text-formatting"
    ],
    "unicode": "e631",
    "id": 368,
    "tags": [
      "borders",
      "inside",
      "horizontal",
      "border",
      "h",
      "text-formatting"
    ]
  },
  {
    "name": "borders-inside-vertical",
    "ligatures": [],
    "aliases": [
      "borders-inside-v",
      "inside-vertical-borders"
    ],
    "categories": [
      "text-formatting"
    ],
    "unicode": "e632",
    "id": 369,
    "tags": [
      "borders",
      "inside",
      "vertical",
      "v",
      "text-formatting"
    ]
  },
  {
    "name": "border-top",
    "ligatures": [],
    "aliases": [
      "top-border"
    ],
    "categories": [
      "text-formatting"
    ],
    "unicode": "e633",
    "id": 370,
    "tags": [
      "border",
      "top",
      "text-formatting"
    ]
  },
  {
    "name": "border-bottom",
    "ligatures": [],
    "aliases": [
      "bottom-border"
    ],
    "categories": [
      "text-formatting"
    ],
    "unicode": "e634",
    "id": 371,
    "tags": [
      "border",
      "bottom",
      "text-formatting"
    ]
  },
  {
    "name": "border-left",
    "ligatures": [],
    "aliases": [
      "left-border"
    ],
    "categories": [
      "text-formatting"
    ],
    "unicode": "e635",
    "id": 372,
    "tags": [
      "border",
      "left",
      "text-formatting"
    ]
  },
  {
    "name": "border-right",
    "ligatures": [],
    "aliases": [
      "right-border"
    ],
    "categories": [
      "text-formatting"
    ],
    "unicode": "e636",
    "id": 373,
    "tags": [
      "border",
      "right",
      "text-formatting"
    ]
  },
  {
    "name": "borders-none",
    "ligatures": [],
    "aliases": [
      "border-no",
      "no-borders"
    ],
    "categories": [
      "text-formatting"
    ],
    "unicode": "e637",
    "id": 374,
    "tags": [
      "borders",
      "none",
      "border",
      "no",
      "text-formatting"
    ]
  },
  {
    "name": "borders-show-hide",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "text-formatting"
    ],
    "unicode": "e638",
    "id": 375,
    "tags": [
      "borders",
      "show",
      "hide",
      "text-formatting"
    ]
  },
  {
    "name": "form-element",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e63a",
    "id": 377,
    "tags": [
      "form",
      "element",
      "editing"
    ]
  },
  {
    "name": "change-manually",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e648",
    "id": 391,
    "tags": [
      "change",
      "manually",
      "editing"
    ]
  },
  {
    "name": "track-changes",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e649",
    "id": 392,
    "tags": [
      "track",
      "changes",
      "editing"
    ]
  },
  {
    "name": "track-changes-enable",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e64a",
    "id": 393,
    "tags": [
      "track",
      "changes",
      "enable",
      "editing"
    ]
  },
  {
    "name": "track-changes-accept",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e64b",
    "id": 394,
    "tags": [
      "track",
      "changes",
      "accept",
      "editing"
    ]
  },
  {
    "name": "track-changes-accept-all",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e64c",
    "id": 395,
    "tags": [
      "track",
      "changes",
      "accept",
      "all",
      "editing"
    ]
  },
  {
    "name": "track-changes-reject",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e64d",
    "id": 396,
    "tags": [
      "track",
      "changes",
      "reject",
      "editing"
    ]
  },
  {
    "name": "track-changes-reject-all",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e64e",
    "id": 397,
    "tags": [
      "track",
      "changes",
      "reject",
      "all",
      "editing"
    ]
  },
  {
    "name": "image-add",
    "ligatures": [],
    "aliases": [
      "image-light-dialog",
      "image-insert",
      "insert-image"
    ],
    "categories": [
      "editing"
    ],
    "unicode": "e652",
    "id": 401,
    "tags": [
      "image",
      "add",
      "light",
      "dialog",
      "insert",
      "editing",
      "photo",
      "picture",
      "gallery",
      "plus",
      "create",
      "new"
    ]
  },
  {
    "name": "image-edit",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e653",
    "id": 402,
    "tags": [
      "image",
      "edit",
      "editing",
      "photo",
      "picture",
      "gallery",
      "write",
      "modify",
      "pencil"
    ]
  },
  {
    "name": "image-map-editor",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e654",
    "id": 403,
    "tags": [
      "image",
      "map",
      "editor",
      "editing",
      "photo",
      "picture",
      "gallery",
      "location",
      "navigation",
      "place"
    ]
  },
  {
    "name": "link-add",
    "ligatures": [],
    "aliases": [
      "hyperlink-light-dialog",
      "hyperlink-insert"
    ],
    "categories": [
      "editing"
    ],
    "unicode": "e671",
    "id": 432,
    "tags": [
      "link",
      "add",
      "hyperlink",
      "light",
      "dialog",
      "insert",
      "editing",
      "chain",
      "url",
      "plus",
      "create",
      "new"
    ]
  },
  {
    "name": "globe-link",
    "ligatures": [],
    "aliases": [
      "hyperlink-globe"
    ],
    "categories": [
      "editing"
    ],
    "unicode": "e672",
    "id": 433,
    "tags": [
      "globe",
      "link",
      "hyperlink",
      "editing",
      "world",
      "earth",
      "international",
      "web",
      "chain",
      "url"
    ]
  },
  {
    "name": "table-add",
    "ligatures": [],
    "aliases": [
      "table-light-dialog",
      "table-insert",
      "create-table"
    ],
    "categories": [
      "editing"
    ],
    "unicode": "e676",
    "id": 437,
    "tags": [
      "table",
      "add",
      "light",
      "dialog",
      "insert",
      "create",
      "editing",
      "grid",
      "spreadsheet",
      "data",
      "plus",
      "new"
    ]
  },
  {
    "name": "table",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e677",
    "id": 438,
    "tags": [
      "tables",
      "tabular",
      "spreadsheets",
      "excel",
      "grid",
      "form"
    ]
  },
  {
    "name": "table-properties",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e678",
    "id": 439,
    "tags": [
      "table",
      "properties",
      "editing",
      "grid",
      "spreadsheet",
      "data"
    ]
  },
  {
    "name": "table-cell",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e679",
    "id": 440,
    "tags": [
      "table",
      "cell",
      "editing",
      "grid",
      "spreadsheet",
      "data"
    ]
  },
  {
    "name": "table-cell-properties",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e67a",
    "id": 441,
    "tags": [
      "table",
      "cell",
      "properties",
      "editing",
      "grid",
      "spreadsheet",
      "data"
    ]
  },
  {
    "name": "table-column-insert-left",
    "ligatures": [],
    "aliases": [
      "add-column-left"
    ],
    "categories": [
      "editing"
    ],
    "unicode": "e67b",
    "id": 442,
    "tags": [
      "table",
      "column",
      "insert",
      "left",
      "add",
      "editing",
      "grid",
      "spreadsheet",
      "data"
    ]
  },
  {
    "name": "table-column-insert-right",
    "ligatures": [],
    "aliases": [
      "add-column-right"
    ],
    "categories": [
      "editing"
    ],
    "unicode": "e67c",
    "id": 443,
    "tags": [
      "table",
      "column",
      "insert",
      "right",
      "add",
      "editing",
      "grid",
      "spreadsheet",
      "data"
    ]
  },
  {
    "name": "table-row-insert-above",
    "ligatures": [],
    "aliases": [
      "add-row-above"
    ],
    "categories": [
      "editing"
    ],
    "unicode": "e67d",
    "id": 444,
    "tags": [
      "table",
      "row",
      "insert",
      "above",
      "add",
      "editing",
      "grid",
      "spreadsheet",
      "data"
    ]
  },
  {
    "name": "table-row-insert-below",
    "ligatures": [],
    "aliases": [
      "add-row-below"
    ],
    "categories": [
      "editing"
    ],
    "unicode": "e67e",
    "id": 445,
    "tags": [
      "table",
      "row",
      "insert",
      "below",
      "add",
      "editing",
      "grid",
      "spreadsheet",
      "data"
    ]
  },
  {
    "name": "table-column-delete",
    "ligatures": [],
    "aliases": [
      "delete-column"
    ],
    "categories": [
      "editing"
    ],
    "unicode": "e67f",
    "id": 446,
    "tags": [
      "table",
      "column",
      "delete",
      "editing",
      "grid",
      "spreadsheet",
      "data",
      "remove",
      "trash",
      "destroy"
    ]
  },
  {
    "name": "table-row-delete",
    "ligatures": [],
    "aliases": [
      "delete-row"
    ],
    "categories": [
      "editing"
    ],
    "unicode": "e680",
    "id": 447,
    "tags": [
      "table",
      "row",
      "delete",
      "editing",
      "grid",
      "spreadsheet",
      "data",
      "remove",
      "trash",
      "destroy"
    ]
  },
  {
    "name": "table-cell-delete",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e681",
    "id": 448,
    "tags": [
      "table",
      "cell",
      "delete",
      "editing",
      "grid",
      "spreadsheet",
      "data",
      "remove",
      "trash",
      "destroy"
    ]
  },
  {
    "name": "cells-merge",
    "ligatures": [],
    "aliases": [
      "merge-cells"
    ],
    "categories": [
      "editing"
    ],
    "unicode": "e683",
    "id": 450,
    "tags": [
      "cells",
      "merge",
      "editing"
    ]
  },
  {
    "name": "cells-merge-horizontally",
    "ligatures": [],
    "aliases": [
      "cells-merge-h",
      "merge-horizontally"
    ],
    "categories": [
      "editing"
    ],
    "unicode": "e684",
    "id": 451,
    "tags": [
      "cells",
      "merge",
      "horizontally",
      "h",
      "editing"
    ]
  },
  {
    "name": "cells-merge-vertically",
    "ligatures": [],
    "aliases": [
      "cells-merge-v",
      "merge-vertically"
    ],
    "categories": [
      "editing"
    ],
    "unicode": "e685",
    "id": 452,
    "tags": [
      "cells",
      "merge",
      "vertically",
      "v",
      "editing"
    ]
  },
  {
    "name": "cell-split-horizontally",
    "ligatures": [],
    "aliases": [
      "cells-split-h"
    ],
    "categories": [
      "editing"
    ],
    "unicode": "e686",
    "id": 453,
    "tags": [
      "cell",
      "split",
      "horizontally",
      "cells",
      "h",
      "editing"
    ]
  },
  {
    "name": "cell-split-vertically",
    "ligatures": [],
    "aliases": [
      "cells-split-v"
    ],
    "categories": [
      "editing"
    ],
    "unicode": "e687",
    "id": 454,
    "tags": [
      "cell",
      "split",
      "vertically",
      "cells",
      "v",
      "editing"
    ]
  },
  {
    "name": "pane-freeze",
    "ligatures": [],
    "aliases": [
      "freeze-pane"
    ],
    "categories": [
      "editing"
    ],
    "unicode": "e689",
    "id": 456,
    "tags": [
      "pane",
      "freeze",
      "editing"
    ]
  },
  {
    "name": "row-freeze",
    "ligatures": [],
    "aliases": [
      "freeze-row"
    ],
    "categories": [
      "editing"
    ],
    "unicode": "e68a",
    "id": 457,
    "tags": [
      "row",
      "freeze",
      "editing"
    ]
  },
  {
    "name": "column-freeze",
    "ligatures": [],
    "aliases": [
      "col-freeze",
      "freeze-col"
    ],
    "categories": [
      "editing"
    ],
    "unicode": "e68b",
    "id": 458,
    "tags": [
      "column",
      "freeze",
      "col",
      "editing"
    ]
  },
  {
    "name": "decimal-increase",
    "ligatures": [],
    "aliases": [
      "increace-decimal"
    ],
    "categories": [
      "editing"
    ],
    "unicode": "e697",
    "id": 470,
    "tags": [
      "decimal",
      "increase",
      "increace",
      "editing"
    ]
  },
  {
    "name": "decimal-decrease",
    "ligatures": [],
    "aliases": [
      "decrease-decimal"
    ],
    "categories": [
      "editing"
    ],
    "unicode": "e698",
    "id": 471,
    "tags": [
      "decimal",
      "decrease",
      "editing"
    ]
  },
  {
    "name": "image-absolute-position",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e69a",
    "id": 473,
    "tags": [
      "image",
      "absolute",
      "position",
      "editing",
      "photo",
      "picture",
      "gallery"
    ]
  },
  {
    "name": "table-wizard",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e69b",
    "id": 474,
    "tags": [
      "table",
      "wizard",
      "editing",
      "grid",
      "spreadsheet",
      "data"
    ]
  },
  {
    "name": "crosstab",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e69c",
    "id": 475,
    "tags": [
      "crosstab",
      "editing"
    ]
  },
  {
    "name": "crosstab-wizard",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e69d",
    "id": 476,
    "tags": [
      "crosstab",
      "wizard",
      "editing"
    ]
  },
  {
    "name": "table-body",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e69e",
    "id": 477,
    "tags": [
      "table",
      "body",
      "editing",
      "grid",
      "spreadsheet",
      "data"
    ]
  },
  {
    "name": "table-column-groups",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e69f",
    "id": 478,
    "tags": [
      "table",
      "column",
      "groups",
      "editing",
      "grid",
      "spreadsheet",
      "data"
    ]
  },
  {
    "name": "table-corner",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e6a0",
    "id": 479,
    "tags": [
      "table",
      "corner",
      "editing",
      "grid",
      "spreadsheet",
      "data"
    ]
  },
  {
    "name": "table-row-groups",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "editing"
    ],
    "unicode": "e6a1",
    "id": 480,
    "tags": [
      "table",
      "row",
      "groups",
      "editing",
      "grid",
      "spreadsheet",
      "data"
    ]
  },
  {
    "name": "folder-up",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "files-and-folders"
    ],
    "unicode": "e903",
    "id": 535,
    "tags": [
      "folder",
      "up",
      "files-and-folders",
      "directory",
      "files"
    ]
  },
  {
    "name": "file-mdb",
    "ligatures": [],
    "aliases": [
      "mdb"
    ],
    "categories": [
      "files-and-folders"
    ],
    "unicode": "e90c",
    "id": 544,
    "tags": [
      "file",
      "mdb",
      "files-and-folders",
      "document",
      "page",
      "paper"
    ]
  },
  {
    "name": "file-psd",
    "ligatures": [],
    "aliases": [
      "psd"
    ],
    "categories": [
      "files-and-folders"
    ],
    "unicode": "e90f",
    "id": 547,
    "tags": [
      "file",
      "psd",
      "files-and-folders",
      "document",
      "page",
      "paper"
    ]
  },
  {
    "name": "file-config",
    "ligatures": [],
    "aliases": [
      "config"
    ],
    "categories": [
      "files-and-folders"
    ],
    "unicode": "e911",
    "id": 549,
    "tags": [
      "file",
      "config",
      "files-and-folders",
      "document",
      "page",
      "paper"
    ]
  },
  {
    "name": "css3",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "files-and-folders"
    ],
    "unicode": "e916",
    "id": 554,
    "tags": [
      "css3",
      "files-and-folders"
    ]
  },
  {
    "name": "html5",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "files-and-folders"
    ],
    "unicode": "e917",
    "id": 555,
    "tags": [
      "html5",
      "files-and-folders"
    ]
  },
  {
    "name": "file-horizontal",
    "ligatures": [],
    "aliases": [
      "page-landscape",
      "file-h"
    ],
    "categories": [
      "files-and-folders"
    ],
    "unicode": "e922",
    "id": 566,
    "tags": [
      "file",
      "horizontal",
      "page",
      "landscape",
      "h",
      "files-and-folders",
      "document",
      "paper"
    ]
  },
  {
    "name": "file-header",
    "ligatures": [],
    "aliases": [
      "report-header-section"
    ],
    "categories": [
      "files-and-folders"
    ],
    "unicode": "e925",
    "id": 569,
    "tags": [
      "file",
      "header",
      "report",
      "section",
      "files-and-folders",
      "document",
      "page",
      "paper"
    ]
  },
  {
    "name": "file-footer",
    "ligatures": [],
    "aliases": [
      "report-footer-section"
    ],
    "categories": [
      "files-and-folders"
    ],
    "unicode": "e926",
    "id": 570,
    "tags": [
      "file",
      "footer",
      "report",
      "section",
      "files-and-folders",
      "document",
      "page",
      "paper"
    ]
  },
  {
    "name": "group-header-section",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "files-and-folders"
    ],
    "unicode": "e927",
    "id": 571,
    "tags": [
      "group",
      "header",
      "section",
      "files-and-folders",
      "combine",
      "merge",
      "collect"
    ]
  },
  {
    "name": "group-footer-section",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "files-and-folders"
    ],
    "unicode": "e928",
    "id": 572,
    "tags": [
      "group",
      "footer",
      "section",
      "files-and-folders",
      "combine",
      "merge",
      "collect"
    ]
  },
  {
    "name": "toc-section",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "files-and-folders"
    ],
    "unicode": "e92c",
    "id": 576,
    "tags": [
      "toc",
      "section",
      "files-and-folders"
    ]
  },
  {
    "name": "group-section",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "files-and-folders"
    ],
    "unicode": "e92d",
    "id": 577,
    "tags": [
      "group",
      "section",
      "files-and-folders",
      "combine",
      "merge",
      "collect"
    ]
  },
  {
    "name": "data-csv",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "files-and-folders"
    ],
    "unicode": "e92f",
    "id": 579,
    "tags": [
      "data",
      "csv",
      "files-and-folders",
      "spreadsheet",
      "table"
    ]
  },
  {
    "name": "data-json",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "files-and-folders"
    ],
    "unicode": "e930",
    "id": 580,
    "tags": [
      "data",
      "json",
      "files-and-folders",
      "code",
      "format"
    ]
  },
  {
    "name": "data-sql",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "files-and-folders"
    ],
    "unicode": "e931",
    "id": 581,
    "tags": [
      "data",
      "sql",
      "files-and-folders"
    ]
  },
  {
    "name": "data-web",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "files-and-folders"
    ],
    "unicode": "e932",
    "id": 582,
    "tags": [
      "data",
      "web",
      "files-and-folders"
    ]
  },
  {
    "name": "parameter-float",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "files-and-folders"
    ],
    "unicode": "e936",
    "id": 586,
    "tags": [
      "parameter",
      "float",
      "files-and-folders"
    ]
  },
  {
    "name": "parameter-integer",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "files-and-folders"
    ],
    "unicode": "e937",
    "id": 587,
    "tags": [
      "parameter",
      "integer",
      "files-and-folders"
    ]
  },
  {
    "name": "parameter-string",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "files-and-folders"
    ],
    "unicode": "e938",
    "id": 588,
    "tags": [
      "parameter",
      "string",
      "files-and-folders"
    ]
  },
  {
    "name": "toc-section-level",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "files-and-folders"
    ],
    "unicode": "e939",
    "id": 589,
    "tags": [
      "toc",
      "section",
      "level",
      "files-and-folders"
    ]
  },
  {
    "name": "file-presentation",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "files-and-folders"
    ],
    "unicode": "e93e",
    "id": 594,
    "tags": [
      "file",
      "presentation",
      "files-and-folders",
      "document",
      "page",
      "paper"
    ]
  },
  {
    "name": "file-disc-image",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "files-and-folders"
    ],
    "unicode": "e940",
    "id": 596,
    "tags": [
      "file",
      "disc",
      "image",
      "files-and-folders",
      "document",
      "page",
      "paper",
      "photo",
      "picture",
      "gallery"
    ]
  },
  {
    "name": "parameters-byte-array",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "files-and-folders"
    ],
    "unicode": "e942",
    "id": 598,
    "tags": [
      "parameters",
      "byte",
      "array",
      "files-and-folders"
    ]
  },
  {
    "name": "parameters-unknown",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "files-and-folders"
    ],
    "unicode": "e943",
    "id": 599,
    "tags": [
      "parameters",
      "unknown",
      "files-and-folders"
    ]
  },
  {
    "name": "files-error",
    "ligatures": [],
    "aliases": [
      "files-validation"
    ],
    "categories": [
      "files-and-folders"
    ],
    "unicode": "e945",
    "id": 601,
    "tags": [
      "files",
      "error",
      "validation",
      "files-and-folders",
      "problem",
      "issue",
      "bug"
    ]
  },
  {
    "name": "data-rest",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "files-and-folders"
    ],
    "unicode": "e946",
    "id": 602,
    "tags": [
      "data",
      "rest",
      "files-and-folders"
    ]
  },
  {
    "name": "table-position-start",
    "ligatures": [],
    "aliases": [
      "table-position-left"
    ],
    "categories": [
      "files-and-folders"
    ],
    "unicode": "e948",
    "id": 604,
    "tags": [
      "table",
      "position",
      "start",
      "left",
      "files-and-folders",
      "grid",
      "spreadsheet",
      "data"
    ]
  },
  {
    "name": "table-position-center",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "files-and-folders"
    ],
    "unicode": "e949",
    "id": 605,
    "tags": [
      "table",
      "position",
      "center",
      "files-and-folders",
      "grid",
      "spreadsheet",
      "data"
    ]
  },
  {
    "name": "table-position-end",
    "ligatures": [],
    "aliases": [
      "table-position-right"
    ],
    "categories": [
      "files-and-folders"
    ],
    "unicode": "e94a",
    "id": 606,
    "tags": [
      "table",
      "position",
      "end",
      "right",
      "files-and-folders",
      "grid",
      "spreadsheet",
      "data"
    ]
  },
  {
    "name": "list-roman-upper",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "files-and-folders"
    ],
    "unicode": "e94b",
    "id": 607,
    "tags": [
      "list",
      "roman",
      "upper",
      "files-and-folders",
      "bullet",
      "items",
      "menu"
    ]
  },
  {
    "name": "list-roman-lower",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "files-and-folders"
    ],
    "unicode": "e94c",
    "id": 608,
    "tags": [
      "list",
      "roman",
      "lower",
      "files-and-folders",
      "bullet",
      "items",
      "menu"
    ]
  },
  {
    "name": "chart-column-clustered",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "charts"
    ],
    "unicode": "ea01",
    "id": 612,
    "tags": [
      "chart",
      "column",
      "clustered",
      "charts",
      "graph",
      "analytics",
      "statistics"
    ]
  },
  {
    "name": "chart-column-stacked",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "charts"
    ],
    "unicode": "ea02",
    "id": 613,
    "tags": [
      "chart",
      "column",
      "stacked",
      "charts",
      "graph",
      "analytics",
      "statistics"
    ]
  },
  {
    "name": "chart-column-stacked100",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "charts"
    ],
    "unicode": "ea03",
    "id": 614,
    "tags": [
      "chart",
      "column",
      "stacked100",
      "charts",
      "graph",
      "analytics",
      "statistics"
    ]
  },
  {
    "name": "chart-column-range",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "charts"
    ],
    "unicode": "ea04",
    "id": 615,
    "tags": [
      "chart",
      "column",
      "range",
      "charts",
      "graph",
      "analytics",
      "statistics"
    ]
  },
  {
    "name": "chart-bar-clustered",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "charts"
    ],
    "unicode": "ea05",
    "id": 616,
    "tags": [
      "chart",
      "bar",
      "clustered",
      "charts",
      "graph",
      "analytics",
      "statistics",
      "column"
    ]
  },
  {
    "name": "chart-bar-stacked",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "charts"
    ],
    "unicode": "ea06",
    "id": 617,
    "tags": [
      "chart",
      "bar",
      "stacked",
      "charts",
      "graph",
      "analytics",
      "statistics",
      "column"
    ]
  },
  {
    "name": "chart-bar-stacked100",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "charts"
    ],
    "unicode": "ea07",
    "id": 618,
    "tags": [
      "chart",
      "bar",
      "stacked100",
      "charts",
      "graph",
      "analytics",
      "statistics",
      "column"
    ]
  },
  {
    "name": "chart-bar-range",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "charts"
    ],
    "unicode": "ea08",
    "id": 619,
    "tags": [
      "chart",
      "bar",
      "range",
      "charts",
      "graph",
      "analytics",
      "statistics",
      "column"
    ]
  },
  {
    "name": "chart-area-clustered",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "charts"
    ],
    "unicode": "ea09",
    "id": 620,
    "tags": [
      "chart",
      "area",
      "clustered",
      "charts",
      "graph",
      "analytics",
      "statistics",
      "region"
    ]
  },
  {
    "name": "chart-area-stacked",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "charts"
    ],
    "unicode": "ea0a",
    "id": 621,
    "tags": [
      "chart",
      "area",
      "stacked",
      "charts",
      "graph",
      "analytics",
      "statistics",
      "region"
    ]
  },
  {
    "name": "chart-area-stacked100",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "charts"
    ],
    "unicode": "ea0b",
    "id": 622,
    "tags": [
      "chart",
      "area",
      "stacked100",
      "charts",
      "graph",
      "analytics",
      "statistics",
      "region"
    ]
  },
  {
    "name": "chart-area-range",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "charts"
    ],
    "unicode": "ea0c",
    "id": 623,
    "tags": [
      "chart",
      "area",
      "range",
      "charts",
      "graph",
      "analytics",
      "statistics",
      "region"
    ]
  },
  {
    "name": "chart-line",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "charts"
    ],
    "unicode": "ea0d",
    "id": 624,
    "tags": [
      "graphs",
      "graphing",
      "charts",
      "statistics",
      "analyze",
      "analysis",
      "stocks"
    ]
  },
  {
    "name": "chart-line-stacked",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "charts"
    ],
    "unicode": "ea0e",
    "id": 625,
    "tags": [
      "chart",
      "line",
      "stacked",
      "charts",
      "graph",
      "analytics",
      "statistics",
      "trend"
    ]
  },
  {
    "name": "chart-line-stacked100",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "charts"
    ],
    "unicode": "ea0f",
    "id": 626,
    "tags": [
      "chart",
      "line",
      "stacked100",
      "charts",
      "graph",
      "analytics",
      "statistics",
      "trend"
    ]
  },
  {
    "name": "chart-line-markers",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "charts"
    ],
    "unicode": "ea10",
    "id": 627,
    "tags": [
      "chart",
      "line",
      "markers",
      "charts",
      "graph",
      "analytics",
      "statistics",
      "trend"
    ]
  },
  {
    "name": "chart-line-stacked-markers",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "charts"
    ],
    "unicode": "ea11",
    "id": 628,
    "tags": [
      "chart",
      "line",
      "stacked",
      "markers",
      "charts",
      "graph",
      "analytics",
      "statistics",
      "trend"
    ]
  },
  {
    "name": "chart-line-stacked100-markers",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "charts"
    ],
    "unicode": "ea12",
    "id": 629,
    "tags": [
      "chart",
      "line",
      "stacked100",
      "markers",
      "charts",
      "graph",
      "analytics",
      "statistics",
      "trend"
    ]
  },
  {
    "name": "chart-scatter-smooth-lines-markers",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "charts"
    ],
    "unicode": "ea16",
    "id": 633,
    "tags": [
      "chart",
      "scatter",
      "smooth",
      "lines",
      "markers",
      "charts",
      "graph",
      "analytics",
      "statistics",
      "plot"
    ]
  },
  {
    "name": "chart-scatter-smooth-lines",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "charts"
    ],
    "unicode": "ea17",
    "id": 634,
    "tags": [
      "chart",
      "scatter",
      "smooth",
      "lines",
      "charts",
      "graph",
      "analytics",
      "statistics",
      "plot"
    ]
  },
  {
    "name": "chart-scatter-straight-lines-markers",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "charts"
    ],
    "unicode": "ea18",
    "id": 635,
    "tags": [
      "chart",
      "scatter",
      "straight",
      "lines",
      "markers",
      "charts",
      "graph",
      "analytics",
      "statistics",
      "plot"
    ]
  },
  {
    "name": "chart-scatter-straight-lines",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "charts"
    ],
    "unicode": "ea19",
    "id": 636,
    "tags": [
      "chart",
      "scatter",
      "straight",
      "lines",
      "charts",
      "graph",
      "analytics",
      "statistics",
      "plot"
    ]
  },
  {
    "name": "chart-bubble",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "charts"
    ],
    "unicode": "ea1a",
    "id": 637,
    "tags": [
      "chart",
      "bubble",
      "charts",
      "graph",
      "analytics",
      "statistics",
      "circle",
      "dot"
    ]
  },
  {
    "name": "chart-candlestick",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "charts"
    ],
    "unicode": "ea1b",
    "id": 638,
    "tags": [
      "chart",
      "candlestick",
      "charts",
      "graph",
      "analytics",
      "statistics"
    ]
  },
  {
    "name": "chart-ohlc",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "charts"
    ],
    "unicode": "ea1c",
    "id": 639,
    "tags": [
      "chart",
      "ohlc",
      "charts",
      "graph",
      "analytics",
      "statistics"
    ]
  },
  {
    "name": "chart-radar-markers",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "charts"
    ],
    "unicode": "ea1e",
    "id": 641,
    "tags": [
      "chart",
      "radar",
      "markers",
      "charts",
      "graph",
      "analytics",
      "statistics"
    ]
  },
  {
    "name": "chart-rose",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "charts"
    ],
    "unicode": "ea20",
    "id": 643,
    "tags": [
      "chart",
      "rose",
      "charts",
      "graph",
      "analytics",
      "statistics"
    ]
  },
  {
    "name": "chart-choropleth",
    "ligatures": [],
    "aliases": [],
    "categories": [
      "charts"
    ],
    "unicode": "ea21",
    "id": 644,
    "tags": [
      "chart",
      "choropleth",
      "charts",
      "graph",
      "analytics",
      "statistics"
    ]
  }
];
